import React from "react";
import "./SvgIcon.css";

import SvgIcon from "@material-ui/core/SvgIcon";
export function IconCalendarBlue(props) {
  return (
    <SvgIcon viewBox="0 0 23.127 21.838" {...props}>
      <g transform="translate(-2.5 -5.1)">
        <g transform="translate(2.5 5.1)">
          <path
            fill="#F79824"
            d="M22.928,6.413h-3.21V6a.9.9,0,0,0-.9-.9.877.877,0,0,0-.875.9v.413H10.16V6a.9.9,0,0,0-.9-.9.883.883,0,0,0-.9.9v.413H5.175A2.683,2.683,0,0,0,2.5,9.088V24.263a2.683,2.683,0,0,0,2.675,2.675H22.952a2.683,2.683,0,0,0,2.675-2.675V9.088A2.72,2.72,0,0,0,22.928,6.413ZM5.175,8.213h3.21v.413a.9.9,0,0,0,.9.9.883.883,0,0,0,.9-.9V8.213h7.782v.413a.9.9,0,0,0,.9.9.883.883,0,0,0,.9-.9V8.213h3.21a.9.9,0,0,1,.9.9v1.8H4.275v-1.8A.883.883,0,0,1,5.175,8.213ZM22.928,25.138H5.175a.9.9,0,0,1-.9-.9V12.663H23.827v11.6A.877.877,0,0,1,22.928,25.138Z"
            transform="translate(-2.5 -5.1)"
          />
          <path
            fill="#F79824"
            d="M20.534,43.6H18.2a.9.9,0,1,0,0,1.8h2.359a.9.9,0,0,0,.9-.9A.919.919,0,0,0,20.534,43.6Z"
            transform="translate(-13.701 -34.237)"
          />
          <path
            fill="#F79824"
            d="M44.659,43.6H42.3a.9.9,0,1,0,0,1.8h2.359a.9.9,0,0,0,.9-.9A.883.883,0,0,0,44.659,43.6Z"
            transform="translate(-31.94 -34.237)"
          />
          <path
            fill="#F79824"
            d="M68.859,43.6H66.5a.9.9,0,0,0,0,1.8h2.359a.9.9,0,0,0,.9-.9A.883.883,0,0,0,68.859,43.6Z"
            transform="translate(-50.255 -34.237)"
          />
          <path
            fill="#F79824"
            d="M20.534,58.2H18.2a.9.9,0,1,0,0,1.8h2.359a.9.9,0,0,0,.9-.9A.935.935,0,0,0,20.534,58.2Z"
            transform="translate(-13.701 -45.287)"
          />
          <path
            fill="#F79824"
            d="M44.659,58.2H42.3a.9.9,0,1,0,0,1.8h2.359a.9.9,0,1,0,0-1.8Z"
            transform="translate(-31.94 -45.287)"
          />
          <path
            fill="#F79824"
            d="M68.859,58.2H66.5a.9.9,0,0,0,0,1.8h2.359a.9.9,0,1,0,0-1.8Z"
            transform="translate(-50.255 -45.287)"
          />
          <path
            fill="#F79824"
            d="M20.534,72.9H18.2a.9.9,0,0,0-.9.9.883.883,0,0,0,.9.9h2.359a.9.9,0,1,0-.024-1.8Z"
            transform="translate(-13.701 -56.412)"
          />
          <path
            fill="#F79824"
            d="M44.659,72.9H42.3a.9.9,0,0,0-.9.9.883.883,0,0,0,.9.9h2.359a.9.9,0,0,0,.9-.9A.883.883,0,0,0,44.659,72.9Z"
            transform="translate(-31.94 -56.412)"
          />
          <path
            fill="#F79824"
            d="M68.859,72.9H66.5a.9.9,0,0,0-.9.9.883.883,0,0,0,.9.9h2.359a.9.9,0,0,0,.9-.9A.883.883,0,0,0,68.859,72.9Z"
            transform="translate(-50.255 -56.412)"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
export function InviteIcon(props) {
  return (
    <SvgIcon
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      httpx="0px" //www.w3.org/1999/xlink"
      y="0px"
      viewBox="0 0 1000 1000"
      enable-background="new 0 0 1000 1000"
      xml-space="preserve"
      {...props}
    >
      <metadata>
        {" "}
        Svg Vector Icons : http://www.onlinewebfonts.com/icon{" "}
      </metadata>
      <g>
        <path d="M488.9,560.8c92.5-38.2,157.7-129.4,157.7-235.7c0-140.8-114.2-255-255-255c-140.8,0-255,114.2-255,255c0,106.4,65.1,197.5,157.6,235.7C130.6,603.9,10,752.8,10,929.9h43.6c0-45.6,8.9-89.9,26.5-131.5c17-40.2,41.4-76.4,72.4-107.4c31.1-31.1,67.2-55.4,107.4-72.4c41.6-17.6,85.9-26.5,131.5-26.5c45.6,0,89.9,8.9,131.5,26.5c40.2,17,76.4,41.4,107.4,72.4c31.1,31.1,55.4,67.2,72.4,107.4c17.6,41.6,26.5,85.9,26.5,131.5h43.6C773.1,752.8,652.4,603.9,488.9,560.8z M391.5,536.5c-56.5,0-109.5-22-149.5-61.9c-39.9-39.9-61.9-93-61.9-149.5c0-56.5,22-109.5,61.9-149.5c39.9-39.9,93-61.9,149.5-61.9c56.5,0,109.6,22,149.5,61.9c39.9,39.9,61.9,93,61.9,149.5c0,56.5-22,109.6-61.9,149.5C501.1,514.5,448,536.5,391.5,536.5z" />
        <path d="M859.9,504.1V374h-43.6v130.1H686.2v43.6h130.1v130.1h43.6V547.7H990v-43.6H859.9z" />
      </g>
    </SvgIcon>
  );
}

export function YoutubeIcon(props) {
  return (
    <SvgIcon
      viewBox="0 -77 512.00213 512"
      width="256pt"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m501.453125 56.09375c-5.902344-21.933594-23.195313-39.222656-45.125-45.128906-40.066406-10.964844-200.332031-10.964844-200.332031-10.964844s-160.261719 0-200.328125 10.546875c-21.507813 5.902344-39.222657 23.617187-45.125 45.546875-10.542969 40.0625-10.542969 123.148438-10.542969 123.148438s0 83.503906 10.542969 123.148437c5.90625 21.929687 23.195312 39.222656 45.128906 45.128906 40.484375 10.964844 200.328125 10.964844 200.328125 10.964844s160.261719 0 200.328125-10.546875c21.933594-5.902344 39.222656-23.195312 45.128906-45.125 10.542969-40.066406 10.542969-123.148438 10.542969-123.148438s.421875-83.507812-10.546875-123.570312zm0 0"
        fill="#f00"
      />
      <path
        d="m204.96875 256 133.269531-76.757812-133.269531-76.757813zm0 0"
        fill="#fff"
      />
    </SvgIcon>
  );
}
export function DeleteIcon(props) {
  return (
    <SvgIcon viewBox="0 0 174.239 174.239" {...props}>
      <g>
        <path
          d="M87.12,0C39.082,0,0,39.082,0,87.12s39.082,87.12,87.12,87.12s87.12-39.082,87.12-87.12S135.157,0,87.12,0z M87.12,159.305
		c-39.802,0-72.185-32.383-72.185-72.185S47.318,14.935,87.12,14.935s72.185,32.383,72.185,72.185S126.921,159.305,87.12,159.305z"
        />
        <path
          d="M120.83,53.414c-2.917-2.917-7.647-2.917-10.559,0L87.12,76.568L63.969,53.414c-2.917-2.917-7.642-2.917-10.559,0
		s-2.917,7.642,0,10.559l23.151,23.153L53.409,110.28c-2.917,2.917-2.917,7.642,0,10.559c1.458,1.458,3.369,2.188,5.28,2.188
		c1.911,0,3.824-0.729,5.28-2.188L87.12,97.686l23.151,23.153c1.458,1.458,3.369,2.188,5.28,2.188c1.911,0,3.821-0.729,5.28-2.188
		c2.917-2.917,2.917-7.642,0-10.559L97.679,87.127l23.151-23.153C123.747,61.057,123.747,56.331,120.83,53.414z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </SvgIcon>
  );
}
export function BackArrowSVGIcon(props) {
  return (
    <SvgIcon
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      {...props}
    >
      <title>icon_back_arrow_blue</title>
      <path
        fill="#ffffff"
        d="M21.569 31.175l-14.357-14.185c-0.274-0.274-0.444-0.653-0.444-1.071s0.17-0.797 0.444-1.071v0l14.357-14.203c0.408-0.4 0.968-0.647 1.585-0.647s1.177 0.247 1.585 0.647l-0-0c0.398 0.398 0.644 0.947 0.644 1.554s-0.246 1.156-0.644 1.554v0l-12.314 12.166 12.308 12.129c0.396 0.398 0.641 0.947 0.641 1.554s-0.245 1.156-0.641 1.554l0-0c-0.408 0.4-0.968 0.647-1.585 0.647s-1.177-0.247-1.585-0.647l0 0z"
      />
    </SvgIcon>
  );
}

export function DownloadIconNew(props) {
  const { htmlColor } = props;
  let st0 = {
    fill: htmlColor, //"#007AFF"
  };
  return (
    <SvgIcon
      x="0px"
      y="0px"
      viewBox="0 0 77.4 70.2"
      // style="enable-background:new 0 0 77.4 70.2;"
      {...props}
    >
      <g>
        <path
          style={st0}
          d="M46.7,56.4l-5.5,5.4V38c0-1.4-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5v24l-5.7-5.6c-0.9-1-2.5-1-3.4-0.1
		c0,0,0,0-0.1,0.1c-0.9,0.9-1,2.3-0.2,3.2c0,0.1,0.1,0.1,0.2,0.2l9.9,9.7c0.4,0.5,1.1,0.8,1.8,0.7c0.3,0,0.7,0,1-0.2
		c0.3-0.1,0.6-0.3,0.8-0.6l9.9-9.7c0.9-0.9,1-2.3,0.2-3.2c0-0.1-0.1-0.1-0.2-0.2c-0.9-1-2.5-1-3.4-0.1
		C46.8,56.3,46.8,56.4,46.7,56.4z"
        />
        <path
          style={st0}
          d="M64,19.6C62.8,8.4,53.3-0.1,42,0c-8.8,0.1-16.7,5.2-20.4,13.2c-0.9-0.2-1.8-0.2-2.7-0.2
		C8.6,12.9,0.2,21.1,0,31.5c0.1,10.4,8.6,18.7,19,18.6h6.6c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4H19
		c-7.6,0-13.7-6.1-13.7-13.7S11.4,17.8,19,17.8c0.8,0,1.2,0,1.7,0c0.6,0,1.2,0.1,1.8,0.3h0.1c1.3,0.4,2.7-0.2,3.2-1.5
		C27.9,9.5,34.6,4.7,42,4.8c9.4-0.2,17.1,7.3,17.2,16.6c0,0.1,0,0.2,0,0.4c-0.1,1.3,0.9,2.4,2.1,2.4c0.1,0,0.2,0,0.4,0
		c5.8,0,10.5,4.7,10.5,10.5s-4.7,10.5-10.5,10.5h-9.9c-1.3,0-2.4,1.1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4l0,0h9.9
		c8.5,0.2,15.5-6.5,15.6-15C77.5,27.3,71.8,20.6,64,19.6L64,19.6z"
        />
      </g>
    </SvgIcon>
  );
}

export function AttachmentIcon(props) {
  return (
    <SvgIcon viewBox="0 0 14 24" {...props}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        className="a"
        d="M36.3,7.239a4.286,4.286,0,0,0-8.549,0v9.948a2.75,2.75,0,1,0,5.5,0V9.852a.688.688,0,0,0-.688-.688.665.665,0,0,0-.688.642v7.38a1.375,1.375,0,1,1-2.75,0V7.239a2.911,2.911,0,0,1,5.8,0V19.181a4.424,4.424,0,1,1-8.847,0V7.56a.688.688,0,0,0-.688-.688.665.665,0,0,0-.688.642V19.181a5.8,5.8,0,1,0,11.6,0Z"
        transform="translate(-24.7 -3.267)"
      />
    </SvgIcon>
  );
}
export function DeleteTrashIcon(props) {
  return (
    <SvgIcon viewBox="0 0 34 34" {...props}>
      <path d="M24.262 32h-16.66c-1.56-0.042-2.809-1.316-2.809-2.882 0-0.016 0-0.032 0-0.048l-0 0.002v-21.032h1.702v21.032c-0 0.012-0.001 0.026-0.001 0.040 0 0.628 0.487 1.142 1.103 1.185l0.004 0h16.66c0.627-0.038 1.121-0.556 1.121-1.189 0-0.016-0-0.033-0.001-0.049l0 0.002v-21.021h1.702v21.032c0 0.013 0 0.029 0 0.045 0 1.571-1.256 2.849-2.819 2.883l-0.003 0z" />
      <path d="M27.278 8.889h-22.689c-0.654 0-1.185-0.53-1.185-1.185v0-3.251c0-0.654 0.53-1.185 1.185-1.185v0h22.689c0.654 0 1.185 0.53 1.185 1.185v0 3.251c-0.009 0.65-0.534 1.175-1.184 1.185h-0.001zM5.106 7.197h21.661v-2.237h-21.661z" />
      <path d="M12.783 3.877h-1.702v-1.947c0.010-1.134 0.534-1.93 1.314-1.93h7.077c0.78 0 1.294 0.797 1.294 1.93v1.624h-1.702v-1.624c0.004-0.034 0.006-0.074 0.006-0.114s-0.002-0.080-0.006-0.119l0 0.005h-6.281c-0.011 0.060-0.018 0.129-0.018 0.199 0 0.014 0 0.028 0.001 0.042l-0-0.002v1.947z" />
      <path d="M9.532 11.108h1.692v15.34h-1.692v-15.34z" />
      <path d="M20.64 11.108h1.692v15.34h-1.692v-15.34z" />
      <path d="M15.088 11.108h1.692v15.34h-1.692v-15.34z" />
    </SvgIcon>
  );
}

export function FilterSVGIcon(props) {
  return (
    <SvgIcon
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        fill={props.htmlColor}
        d="M31.555 0.889c-0.275-0.532-0.821-0.889-1.45-0.889-0.001 0-0.002 0-0.003 0h-28.203c-0.899 0-1.627 0.729-1.627 1.627v0c0 0.361 0.118 0.695 0.318 0.964l-0.003-0.004 11.075 15.11v12.675c0 0.899 0.729 1.627 1.627 1.627v0c0.167-0.002 0.327-0.028 0.479-0.074l-0.012 0.003 5.424-1.627c0.676-0.207 1.16-0.825 1.161-1.556v-11.048l11.075-15.111c0.197-0.266 0.316-0.601 0.316-0.964 0-0.268-0.065-0.52-0.179-0.743l0.004 0.009zM17.627 15.919c-0.339 0.448-0.542 1.014-0.542 1.627v0 9.991l-2.169 0.651v-10.668c0-0.614-0.204-1.18-0.547-1.634l0.005 0.007-9.264-12.637h21.782z"
      />
    </SvgIcon>
  );
}
export function ActiveFilterSVGIcon(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="82"
      height="82"
      viewBox="0 0 82 82"
      {...props}
    >
      <rect width="82" height="82" rx="12" fill={props.htmlColor} />
      <path
        d="M50.4,84.5a5.18,5.18,0,0,1-5.15-5.17V62.9a2.57,2.57,0,0,0-.48-1.49L22.93,30.88a5.4,5.4,0,0,1-.27-5.58,5.34,5.34,0,0,1,4.71-2.8H78.63a5.36,5.36,0,0,1,4.5,8.28L61.23,61.41a2.5,2.5,0,0,0-.48,1.49V78a5.16,5.16,0,0,1-3.92,5l-5.16,1.29A5,5,0,0,1,50.4,84.5ZM27.13,27.87,49,58.4a7.66,7.66,0,0,1,1.44,4.5V79.34L55.58,78V62.9A7.62,7.62,0,0,1,57,58.4L78.86,27.88l-.23-.21H27.37L25,29.38Z"
        transform="translate(-12 -12.5)"
        fill={"#fff"}
      />
    </SvgIcon>
  );
}
export function SortSVGIcon(props) {
  return (
    <SvgIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M18.793 5.833h-17.46c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333v0h17.46c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333v0z" />
      <path d="M14.927 14.607h-13.593c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333v0h13.593c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333v0z" />
      <path d="M11.4 23.367h-10.067c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333v0h10.067c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333v0z" />
      <path d="M31.667 20.15c-0.242-0.245-0.577-0.396-0.948-0.396s-0.706 0.151-0.948 0.396l-1.547 1.547v-14.487c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333v0 0 14.49l-1.557-1.55c-0.242-0.242-0.577-0.392-0.947-0.392-0.74 0-1.34 0.6-1.34 1.34 0 0.37 0.15 0.706 0.393 0.948l3.83 3.833c0.242 0.244 0.577 0.394 0.947 0.394s0.705-0.151 0.947-0.394l3.837-3.833c0.245-0.242 0.396-0.577 0.396-0.948s-0.151-0.706-0.396-0.948l-0-0z" />
    </SvgIcon>
  );
}
export function SortUpDownSVGIcon(props) {
  return (
    <SvgIcon
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      {...props}
    >
      <path d="M6.269 8.606v0c0.006-0 0.014-0 0.021-0 0.766 0 1.388 0.613 1.404 1.375l0 0.001v7.952c-0.001 0.011-0.002 0.023-0.002 0.035 0 0.090 0.035 0.172 0.091 0.234l-0-0c0.089 0.089 0.344 0.175 0.444 0v0l1.958-1.958c0.254-0.277 0.618-0.449 1.022-0.449 0.766 0 1.387 0.621 1.387 1.387 0 0.362-0.139 0.692-0.366 0.939l0.001-0.001-4.979 4.979c-0.252 0.248-0.598 0.4-0.979 0.4s-0.727-0.153-0.979-0.401l-4.893-4.889c-0.248-0.252-0.4-0.598-0.4-0.979s0.153-0.727 0.401-0.979l-0 0c0.252-0.248 0.598-0.4 0.979-0.4s0.727 0.153 0.979 0.401l1.958 1.958c0.061 0.056 0.143 0.091 0.233 0.091 0.011 0 0.022-0.001 0.033-0.002l-0.001 0c0.189-0.011 0.341-0.157 0.361-0.342l0-0.002v-7.914c-0.005-0.042-0.007-0.090-0.007-0.138 0-0.661 0.499-1.206 1.141-1.279l0.006-0.001c0.029-0.002 0.064-0.004 0.098-0.004s0.069 0.001 0.103 0.004l-0.004-0z" />
      <path d="M25.634 23.505v0c-0.005 0-0.011 0-0.018 0-0.766 0-1.39-0.613-1.407-1.375l-0-0.002v-7.952c0.001-0.010 0.001-0.021 0.001-0.032 0-0.090-0.035-0.172-0.091-0.233l0 0c-0.089-0.089-0.344-0.179-0.444 0v0l-1.958 1.954c-0.254 0.277-0.618 0.45-1.022 0.45-0.765 0-1.386-0.62-1.386-1.386 0-0.361 0.138-0.69 0.365-0.937l-0.001 0.001 0.089-0.089 4.889-4.896c0.252-0.248 0.598-0.4 0.979-0.4s0.727 0.153 0.979 0.401l-0-0 4.893 4.9c0.247 0.251 0.4 0.596 0.4 0.977s-0.153 0.726-0.4 0.977l0-0c-0.25 0.252-0.596 0.409-0.979 0.409s-0.729-0.156-0.979-0.409l-0-0-1.958-1.954c-0.057-0.057-0.136-0.092-0.223-0.092-0.015 0-0.029 0.001-0.043 0.003l0.002-0c-0.182 0.018-0.326 0.162-0.344 0.342l-0 0.002v7.914c0.005 0.042 0.007 0.090 0.007 0.138 0 0.661-0.499 1.206-1.14 1.279l-0.006 0.001c-0.029 0.002-0.064 0.004-0.098 0.004s-0.069-0.001-0.102-0.004l0.004 0z" />
    </SvgIcon>
  );
}

export function SortDownBlueIcon(props) {
  return (
    <SvgIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="#2973f6"
        d="M27.111 32h-22.222c-2.69-0.025-4.864-2.199-4.889-4.886l-0-0.002v-22.222c0.025-2.69 2.199-4.864 4.886-4.889l0.002-0h22.222c2.69 0.025 4.864 2.199 4.889 4.886l0 0.002v22.222c-0.025 2.69-2.199 4.864-4.886 4.889l-0.002 0zM4.889 2.667c-0.005-0-0.012-0-0.018-0-1.211 0-2.194 0.977-2.204 2.186v22.223c-0 0.016-0.001 0.035-0.001 0.053 0 1.211 0.977 2.195 2.186 2.204h22.223c0.016 0 0.035 0.001 0.053 0.001 1.211 0 2.195-0.977 2.204-2.186v-22.259c0-0.005 0-0.012 0-0.018 0-1.211-0.977-2.194-2.186-2.204h-22.259z"
      ></path>
      <path
        fill="#2973f6"
        d="M16 8.453v0c0.005-0 0.012-0 0.018-0 0.779 0 1.412 0.627 1.422 1.404v8.001c-0.001 0.009-0.001 0.019-0.001 0.029 0 0.094 0.034 0.18 0.090 0.247l-0-0.001c0.098 0.089 0.364 0.178 0.453 0v0l1.982-1.982c0.259-0.309 0.646-0.504 1.078-0.504 0.776 0 1.404 0.629 1.404 1.404 0 0.388-0.157 0.739-0.411 0.993l-0.089 0.089-4.987 4.978c-0.255 0.251-0.605 0.406-0.991 0.406s-0.736-0.155-0.991-0.406l-4.951-4.951c-0.251-0.255-0.406-0.605-0.406-0.991s0.155-0.736 0.406-0.991l-0 0c0.255-0.251 0.605-0.406 0.991-0.406s0.736 0.155 0.991 0.406l1.982 1.982c0.059 0.056 0.139 0.091 0.227 0.091 0.014 0 0.027-0.001 0.041-0.003l-0.002 0c0.196-0.005 0.355-0.16 0.364-0.355l0-0.001v-8c-0.004-0.040-0.007-0.086-0.007-0.133 0-0.673 0.505-1.227 1.156-1.306l0.006-0.001h0.222z"
      ></path>
    </SvgIcon>
  );
}
export function SortUpBlueIcon(props) {
  return (
    <SvgIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="#2973f6"
        d="M4.889 0h22.222c2.69 0.025 4.864 2.199 4.889 4.886l0 0.002v22.222c-0.025 2.69-2.199 4.864-4.887 4.889l-0.002 0h-22.222c-2.69-0.025-4.864-2.199-4.889-4.887l-0-0.002v-22.222c0.025-2.69 2.199-4.864 4.886-4.889l0.002-0zM27.111 29.333c0.005 0 0.012 0 0.018 0 1.211 0 2.194-0.977 2.204-2.186v-22.259c0-0.005 0-0.012 0-0.018 0-1.211-0.977-2.194-2.186-2.204h-22.259c-0.005-0-0.012-0-0.018-0-1.211 0-2.194 0.977-2.204 2.186v22.223c-0 0.016-0.001 0.035-0.001 0.053 0 1.211 0.977 2.195 2.186 2.204h22.223z"
      ></path>
      <path
        fill="#2973f6"
        d="M16 23.547v0c-0.005 0-0.012 0-0.018 0-0.779 0-1.412-0.627-1.422-1.404v-8.001c0.001-0.009 0.001-0.019 0.001-0.029 0-0.094-0.034-0.18-0.090-0.247l0 0.001c-0.098-0.089-0.364-0.178-0.453 0v0l-1.982 1.982c-0.259 0.309-0.646 0.504-1.078 0.504-0.776 0-1.404-0.629-1.404-1.404 0-0.388 0.157-0.739 0.411-0.993l0.089-0.089 4.987-4.978c0.255-0.251 0.605-0.406 0.991-0.406s0.736 0.155 0.991 0.406l4.951 4.951c0.251 0.255 0.406 0.605 0.406 0.991s-0.155 0.736-0.406 0.991l0-0c-0.255 0.251-0.605 0.406-0.991 0.406s-0.736-0.155-0.991-0.406l-1.982-1.982c-0.059-0.056-0.139-0.091-0.227-0.091-0.014 0-0.027 0.001-0.041 0.003l0.002-0c-0.196 0.005-0.355 0.16-0.364 0.355l-0 0.001v8c0.004 0.040 0.007 0.086 0.007 0.133 0 0.673-0.505 1.227-1.156 1.306l-0.006 0.001h-0.222z"
      ></path>
    </SvgIcon>
  );
}
export function SortDownGreyIcon(props) {
  return (
    <SvgIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="#b3b3b3"
        d="M27.111 32h-22.222c-2.69-0.025-4.864-2.199-4.889-4.886l-0-0.002v-22.222c0.025-2.69 2.199-4.864 4.886-4.889l0.002-0h22.222c2.69 0.025 4.864 2.199 4.889 4.886l0 0.002v22.222c-0.025 2.69-2.199 4.864-4.886 4.889l-0.002 0zM4.889 2.667c-0.005-0-0.012-0-0.018-0-1.211 0-2.194 0.977-2.204 2.186v22.223c-0 0.016-0.001 0.035-0.001 0.053 0 1.211 0.977 2.195 2.186 2.204h22.223c0.016 0 0.035 0.001 0.053 0.001 1.211 0 2.195-0.977 2.204-2.186v-22.259c0-0.005 0-0.012 0-0.018 0-1.211-0.977-2.194-2.186-2.204h-22.259z"
      ></path>
      <path
        fill="#b3b3b3"
        d="M16 8.453v0c0.005-0 0.012-0 0.018-0 0.779 0 1.412 0.627 1.422 1.404v8.001c-0.001 0.009-0.001 0.019-0.001 0.029 0 0.094 0.034 0.18 0.090 0.247l-0-0.001c0.098 0.089 0.364 0.178 0.453 0v0l1.982-1.982c0.259-0.309 0.646-0.504 1.078-0.504 0.776 0 1.404 0.629 1.404 1.404 0 0.388-0.157 0.739-0.411 0.993l-0.089 0.089-4.987 4.978c-0.255 0.251-0.605 0.406-0.991 0.406s-0.736-0.155-0.991-0.406l-4.951-4.951c-0.251-0.255-0.406-0.605-0.406-0.991s0.155-0.736 0.406-0.991l-0 0c0.255-0.251 0.605-0.406 0.991-0.406s0.736 0.155 0.991 0.406l1.982 1.982c0.059 0.056 0.139 0.091 0.227 0.091 0.014 0 0.027-0.001 0.041-0.003l-0.002 0c0.196-0.005 0.355-0.16 0.364-0.355l0-0.001v-8c-0.004-0.040-0.007-0.086-0.007-0.133 0-0.673 0.505-1.227 1.156-1.306l0.006-0.001h0.222z"
      ></path>
    </SvgIcon>
  );
}

// strava logo
export function StravaLogoIcon(props) {
  let st0 = {
    fill: "#FC4C02", //htmlColor, //"#007AFF"
  };
  return (
    <SvgIcon
      x="0px"
      y="0px"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 432 91"
      {...props}
    >
      <path
        style={st0}
        d="M74.5 49.5c1.6 2.8 2.5 6.3 2.5 10.4v0.2c0 4.2-0.8 8-2.5 11.4 -1.7 3.4-4.1 6.2-7.1 8.6 -3.1 2.3-6.8 4.1-11.2 5.4 -4.4 1.3-9.3 1.9-14.7 1.9 -8.2 0-15.9-1.1-23-3.4 -7.1-2.3-13.2-5.7-18.3-10.2l14.4-17.1c4.4 3.4 9 5.8 13.8 7.2 4.8 1.5 9.6 2.2 14.4 2.2 2.5 0 4.2-0.3 5.3-0.9 1.1-0.6 1.6-1.5 1.6-2.5v-0.2c0-1.2-0.8-2.1-2.4-2.9 -1.6-0.8-4.5-1.6-8.8-2.4 -4.5-0.9-8.8-2-12.9-3.2 -4.1-1.2-7.7-2.8-10.8-4.7 -3.1-1.9-5.6-4.3-7.4-7.2C5.4 39 4.5 35.4 4.5 31.2V31c0-3.8 0.7-7.4 2.2-10.7 1.5-3.3 3.7-6.2 6.6-8.6 2.9-2.5 6.5-4.4 10.7-5.8 4.2-1.4 9.1-2.1 14.7-2.1 7.8 0 14.7 0.9 20.5 2.8 5.9 1.8 11.1 4.6 15.8 8.3L61.9 33c-3.8-2.8-7.9-4.8-12.1-6.1 -4.3-1.3-8.3-1.9-12-1.9 -2 0-3.5 0.3-4.4 0.9 -1 0.6-1.4 1.4-1.4 2.4v0.2c0 1.1 0.7 2 2.2 2.8 1.5 0.8 4.3 1.6 8.5 2.4 5.1 0.9 9.8 2 14 3.3 4.2 1.3 7.8 3 10.9 5C70.5 44.2 72.9 46.6 74.5 49.5zM75.5 28.1h23.7v57.8h26.9V28.1h23.7V5.3H75.5V28.1zM387.9 0.3l-43.3 85.6h25.8l17.5-34.6 17.6 34.6h25.8L387.9 0.3zM267.3 0.3l43.4 85.6h-25.8l-17.5-34.6 -17.5 34.6h-17.5 -8.3 -22.4l-15.2-23h-0.2 -5.5v23h-26.9V5.3H193c7.2 0 13.1 0.8 17.8 2.5 4.6 1.6 8.4 3.9 11.2 6.7 2.5 2.4 4.3 5.2 5.5 8.3 1.2 3.1 1.8 6.7 1.8 10.8v0.2c0 5.9-1.4 10.9-4.3 14.9 -2.8 4.1-6.7 7.3-11.6 9.7l14 20.4L267.3 0.3zM202.5 35.6c0-2.6-0.9-4.5-2.8-5.8 -1.8-1.3-4.3-1.9-7.5-1.9h-11.7v15.8h11.6c3.2 0 5.8-0.7 7.6-2.1 1.8-1.4 2.8-3.3 2.8-5.8V35.6zM345.2 5.3L327.6 40 310 5.3h-25.8l43.4 85.6 43.3-85.6H345.2z"
      />
    </SvgIcon>
  );
}

export function GarminLogoIcon(props) {
  return (
    // <div style={{ height: "25%", width: "25%" }}>
    <SvgIcon
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns-xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 289.124 77.842"
      overflow="visible"
      enable-background="new 0 0 289.124 77.842"
      xml-space="preserve"
      {...props}
    >
      <g>
        <g>
          <path d="M75.2,39.37c-0.479-0.964-1.754-1.751-2.833-1.751h-2.193c-1.077,0-2.337,0.796-2.803,1.767L49.985,75.708    c-0.483,0.961,0.042,1.649,1.121,1.649h4.018c1.586,0,2.313-0.721,2.742-1.605c0.431-0.884,1.389-2.805,1.572-3.197    c0.248-0.53,1.012-0.855,2.089-0.854l18.707,0.01c1.078,0.002,1.771,0.207,2.09,0.844c0.208,0.415,1.164,2.143,1.634,3.086    c0.474,0.943,1.27,1.716,2.815,1.716h5.83c1.078,0,1.55-0.818,1.162-1.578C93.375,75.017,75.2,39.37,75.2,39.37z M64.216,66.091    c-1.077,0-1.584-0.802-1.131-1.777l6.851-14.677c0.456-0.978,1.193-0.971,1.638,0.006l6.67,14.677    c0.445,0.979-0.072,1.781-1.148,1.781L64.216,66.091z M209.543,39.651c0,0.351,0,35.328,0,36.034c0,0.992,0.881,1.672,1.96,1.672    h4.751c1.077,0,1.959-0.688,1.959-1.766V39.578c0-1.079-0.696-1.958-1.773-1.958h-4.937    C210.424,37.619,209.543,38.282,209.543,39.651z M129.927,62.221c-0.619-0.882-0.279-1.856,0.752-2.164    c0,0,4.105-1.229,6.07-2.991c1.966-1.767,2.954-4.318,2.954-7.643c0-2.174-0.38-4.002-1.137-5.489    c-0.757-1.483-1.842-2.697-3.254-3.626c-1.412-0.934-3.102-1.619-5.07-2.048c-1.971-0.427-4.63-0.552-4.63-0.552    c-1.078-0.049-2.839-0.089-3.915-0.089h-19.73c-1.076,0-1.958,0.879-1.958,1.958v36.014c0,1.079,0.881,1.766,1.958,1.766h4.669    c1.078,0,1.959-0.688,1.959-1.766c0,0,0.003-14.324,0.012-14.324c0.008,0,0.013-0.008,0.013-0.018    c0-0.012,8.851-0.022,8.851-0.022c1.076,0,2.466,0.72,3.089,1.602l9.188,12.937c0.854,1.146,1.666,1.591,2.743,1.591h6.103    c1.078,0,1.247-1.016,0.874-1.544C139.099,75.288,129.927,62.221,129.927,62.221z M126.212,54.907    c-1.209,0.278-2.57,0.334-2.57,0.334c-1.076,0.047-2.837,0.085-3.915,0.085h-9.146c-1.078,0-1.959-0.882-1.959-1.959V46.07    c0-1.078,0.881-1.959,1.959-1.959h9.146c1.078,0,2.839,0.039,3.915,0.084c0,0,1.361,0.054,2.57,0.333    c1.209,0.279,2.168,0.668,2.87,1.171c0.705,0.506,1.208,1.099,1.512,1.781c0.3,0.682,0.453,1.425,0.453,2.236    c0,0.807-0.153,1.554-0.453,2.235c-0.304,0.682-0.807,1.275-1.512,1.781C128.38,54.238,127.421,54.632,126.212,54.907z     M267.875,37.619c-1.077,0-1.948,0.71-1.948,1.748c0,0.498,0.012,23.036,0.012,23.036c0,1.08-0.61,1.325-1.358,0.549    l-23.066-23.925c-0.749-0.776-1.845-1.408-3.321-1.408h-4.338c-1.364,0-1.961,0.728-1.961,1.465c0,0.734,0,36.099,0,36.837    c0,0.735,0.7,1.436,1.779,1.436h4.345c1.075,0,1.829-0.586,1.829-1.578c0-0.498,0.022-24.268,0.022-24.268    c0-1.077,0.609-1.323,1.355-0.545l24.051,25.003c0.764,0.765,1.692,1.388,3.343,1.388h3.264c1.079,0,1.96-0.881,1.96-1.959V39.578    c0-1.079-0.881-1.958-1.96-1.958H267.875z M173.832,60.081c-0.523,0.941-1.384,0.938-1.9-0.005L160.657,39.37    c-0.479-0.961-1.462-1.751-2.832-1.751h-6.115c-1.078,0-1.961,0.879-1.961,1.958v35.968c0,1.076,0.708,1.812,1.961,1.812h3.801    c1.079,0,1.856-0.68,1.856-1.719c0-0.498,0.016-26.16,0.057-26.16c0.042,0,14.073,26.153,14.073,26.153    c0.508,0.949,1.755,0.953,2.273,0.008c0,0,14.146-26.086,14.188-26.086c0.044,0,0.028,25.336,0.028,26.085    c0,1.04,0.831,1.719,1.91,1.719h4.378c1.079,0,1.958-0.537,1.958-1.959V39.578c0-1.079-0.879-1.958-1.958-1.958h-5.862    c-1.496,0-2.396,0.763-2.931,1.7L173.832,60.081z" />
        </g>
        <g>
          <path d="M0,57.453c0,19.405,19.848,20.389,23.828,20.389c13.171,0,18.737-3.559,18.968-3.713c0.824-0.466,1.827-1.406,1.827-3.167    V57.568c0-1.234-1.005-2.239-2.24-2.239H25.836c-1.237,0-2.049,1.005-2.049,2.239v1.387c0,1.236,0.812,2.244,2.049,2.244h9.571    c0.924,0,1.675,0.75,1.675,1.674c0,0-0.009,5.871-0.009,6.243c-1.891,0.772-10.503,3.288-17.423,1.638    C9.612,68.353,8.83,60.072,8.83,57.591c0-2.082,0.624-12.512,12.952-13.567c9.979-0.854,16.55,3.175,16.615,3.214    c1.173,0.608,2.387,0.175,3.041-1.067c0.003-0.01,1.245-2.523,1.245-2.523c0.517-1.034,0.343-2.106-0.919-2.962    c-0.084-0.048-7.079-3.841-17.934-3.841C0.668,36.846,0,55.344,0,57.453z" />
        </g>
        <g>
          <path d="M280.067,72.41h-1.705v-0.615h4.15v0.615h-1.713v4.989h-0.732V72.41z" />
          <path d="M288.275,74.938c-0.042-0.782-0.092-1.73-0.092-2.42h-0.017c-0.199,0.648-0.424,1.355-0.706,2.129l-0.99,2.718h-0.549    l-0.915-2.668c-0.266-0.798-0.481-1.514-0.64-2.179h-0.017c-0.017,0.698-0.059,1.63-0.108,2.478l-0.149,2.402h-0.69l0.391-5.604    h0.923l0.957,2.711c0.232,0.69,0.415,1.306,0.565,1.887h0.017c0.149-0.565,0.349-1.18,0.599-1.887l0.998-2.711h0.923l0.35,5.604    h-0.716L288.275,74.938z" />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="XMLID_1_"
                d="M265.682,27.688l-25.992-0.001c-0.953,0-1.771-0.474-2.247-1.299c-0.476-0.825-0.476-1.769,0.001-2.594      l12.997-22.498C250.917,0.472,251.734,0,252.687,0c0.952,0,1.77,0.472,2.246,1.296l12.995,22.499      c0.478,0.825,0.478,1.77,0.001,2.595C267.453,27.214,266.635,27.688,265.682,27.688z"
              />
            </defs>
            <use
              xlink-href="#XMLID_1_"
              fill-rule="evenodd"
              clip-rule="evenodd"
              fill="#007CC2"
            >
              <path
                xmlns="http://www.w3.org/2000/svg"
                id="XMLID_1_"
                d="M265.682,27.688l-25.992-0.001c-0.953,0-1.771-0.474-2.247-1.299c-0.476-0.825-0.476-1.769,0.001-2.594      l12.997-22.498C250.917,0.472,251.734,0,252.687,0c0.952,0,1.77,0.472,2.246,1.296l12.995,22.499      c0.478,0.825,0.478,1.77,0.001,2.595C267.453,27.214,266.635,27.688,265.682,27.688z"
              />
            </use>
            <clipPath id="XMLID_3_">
              <use xlink-href="#XMLID_1_" />
            </clipPath>
          </g>
        </g>
      </g>
    </SvgIcon>
    //{" "}
  );
}

export function FitBitIcon(props) {
  let root = {
    fill: "#142529",
    stroke: "none",
  };
  let root1 = {
    fill: "#142529",
    stroke: "none",
  };
  let root2 = {
    fill: "#2ebec0",
    stroke: "none",
  };
  return (
    <SvgIcon
      version="1.1"
      x="0px"
      y="0px"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 40"
      {...props}
    >
      <path
        d="m 66.842626,15.959 -8.448146,0 0,-4.122 c 0.03841,-4.7775 1.310795,-6.5516 2.712818,-7.4615 1.440434,-0.9459 3.629894,-1.0299 5.735328,-1.0083 0.890668,0 1.608485,-0.7202 1.608485,-1.6085 0,-0.881 -0.717817,-1.5989 -1.608485,-1.5989 -2.086229,0.014 -4.923884,-0.074 -7.456647,1.5005 -2.571175,1.6133 -4.230075,4.8735 -4.194064,10.1767 l 0,4.122 -3.300994,0 c -0.888268,0 -1.608485,0.7226 -1.608485,1.6037 0,0.8859 0.720217,1.6085 1.608485,1.6085 l 3.300994,0 0,24.0384 c 0,0.8763 0.720217,1.5989 1.603684,1.5989 0.888267,0 1.606084,-0.7226 1.606084,-1.5989 -0.0024,-15.3718 -0.0072,-16.4329 -0.0072,-24.0384 l 8.448146,0 c 0.885867,0 1.613286,-0.7226 1.613286,-1.6085 0,-0.8811 -0.727419,-1.6037 -1.613286,-1.6037"
        style={root}
      />
      <path
        d="m 104.62425,41.6095 0,-0.01 c -2.70081,0.024 -4.883071,-0.1368 -6.119444,-1.0635 -1.224369,-0.8787 -2.314297,-2.7825 -2.328702,-7.6343 l 0,-13.6889 8.448146,0 c 0.88587,0 1.60368,-0.7179 1.60368,-1.6037 0,-0.8907 -0.71781,-1.6037 -1.60368,-1.6037 l -8.448146,0 0,-14.2411 c 0,-0.8859 -0.717816,-1.6037 -1.608484,-1.6037 -0.883467,0 -1.596481,0.7178 -1.596481,1.6037 l 0,14.2411 -3.300995,0 c -0.885867,0 -1.608485,0.713 -1.608485,1.6037 0,0.8858 0.722618,1.6037 1.608485,1.6037 l 3.300995,0 0,13.6889 c -0.01921,5.2288 1.219567,8.4721 3.665904,10.2415 2.434334,1.6973 5.286397,1.6493 7.987207,1.6637 0.88587,0 1.60368,-0.7082 1.60368,-1.5989 0,-0.8859 -0.71781,-1.5989 -1.60368,-1.5989"
        style={root}
      />
      <path
        d="m 178.38696,41.6141 0,0 c -3.46184,0.024 -5.57928,-0.3601 -6.60919,-1.3036 -1.05632,-0.8715 -1.85096,-2.8881 -1.83896,-7.3294 l 0,-13.7634 8.44815,0 c 0.89067,0 1.60368,-0.7178 1.60368,-1.6036 0,-0.8907 -0.71301,-1.6037 -1.60368,-1.6037 l -8.44815,0 0,-14.2459 c 0,-0.8907 -0.71541,-1.5941 -1.60368,-1.5941 -0.88827,0 -1.60608,0.7034 -1.60608,1.5941 l 0,14.2459 -3.2986,0 c -0.89067,0 -1.60848,0.713 -1.60848,1.6037 0,0.8858 0.71781,1.6036 1.60848,1.6036 l 3.2986,0 0,13.7634 c 0.01,4.6886 0.73942,7.7855 2.95529,9.7493 2.24948,1.899 5.14715,2.0671 8.70262,2.0815 0.88107,0 1.60368,-0.7083 1.60368,-1.5941 0,-0.8859 -0.72261,-1.5989 -1.60368,-1.5989"
        style={root}
      />
      <path
        d="m 76.563635,43.2084 0,-25.6445 c 0,-0.8835 0.725018,-1.6061 1.603683,-1.6061 0.888268,0 1.608485,0.7226 1.608485,1.6061 l 0,25.6445 c 0,0.8763 -0.720217,1.5989 -1.608485,1.5989 -0.878665,0 -1.603683,-0.7226 -1.603683,-1.5989"
        style={root}
      />
      <path
        d="m 151.01535,43.2084 0,-25.6445 c 0,-0.8835 0.70821,-1.6061 1.58928,-1.6061 0.88587,0 1.60848,0.7226 1.60848,1.6061 l 0,25.6445 c 0,0.8763 -0.72261,1.5989 -1.60848,1.5989 -0.88107,0 -1.58928,-0.7226 -1.58928,-1.5989"
        style={root}
      />
      <path
        d="m 128.78801,41.6705 c -6.24668,-0.014 -11.2978,-5.0559 -11.30981,-11.3026 0.012,-6.2443 5.06313,-11.2954 11.30981,-11.3002 6.24668,0 11.293,5.0559 11.30741,11.3002 -0.0144,6.2467 -5.06073,11.2882 -11.30741,11.3026 m 0,-25.815 c -4.57098,0 -8.64981,2.1199 -11.30981,5.4257 l 0,-19.5155 c 0,-0.8883 -0.71541,-1.6013 -1.59888,-1.6013 -0.89307,0 -1.60368,0.713 -1.60368,1.6013 l 0,29.5697 c 0,0.1128 0.0408,0.2161 0.0648,0.3241 0.64579,7.4038 6.86126,13.2184 14.44755,13.2184 8.01361,0 14.50997,-6.494 14.50997,-14.51 0,-8.0136 -6.49636,-14.5076 -14.50997,-14.5124"
        style={root}
      />
      <path
        d="m 20.475416,22.88215 c 0,1.430611 -1.159753,2.59035 -2.59038,2.59035 -1.430629,0 -2.590381,-1.159739 -2.590381,-2.59035 0,-1.430611 1.159752,-2.59035 2.590381,-2.59035 1.430627,0 2.59038,1.159739 2.59038,2.59035 z"
        style={root1}
      />
      <path
        d="m 28.123341,22.88215 c 0,1.430611 -1.159752,2.59035 -2.59038,2.59035 -1.430628,0 -2.590381,-1.159739 -2.590381,-2.59035 0,-1.430611 1.159753,-2.59035 2.590381,-2.59035 1.430628,0 2.59038,1.159739 2.59038,2.59035 z"
        style={root1}
      />
      <path
        d="m 35.771266,22.88215 c 0,1.430611 -1.159753,2.59035 -2.590381,2.59035 -1.430628,0 -2.590381,-1.159739 -2.590381,-2.59035 0,-1.430611 1.159753,-2.59035 2.590381,-2.59035 1.430628,0 2.590381,1.159739 2.590381,2.59035 z"
        style={root}
      />
      <path
        d="m 12.82749,22.88215 c 0,1.430611 -1.159752,2.59035 -2.59038,2.59035 -1.4306289,0 -2.5903815,-1.159739 -2.5903815,-2.59035 0,-1.430611 1.1597526,-2.59035 2.5903815,-2.59035 1.430628,0 2.59038,1.159739 2.59038,2.59035 z"
        style={root}
      />
      <path
        d="m 20.475416,38.18345 c 0,1.430611 -1.159753,2.59035 -2.590381,2.59035 -1.430628,0 -2.590381,-1.159739 -2.590381,-2.59035 0,-1.430611 1.159753,-2.59035 2.590381,-2.59035 1.430628,0 2.590381,1.159739 2.590381,2.59035 z"
        style={root2}
      />
      <path
        d="m 20.475416,7.59055 c 0,1.430611 -1.159753,2.59035 -2.590381,2.59035 -1.430628,0 -2.590381,-1.159739 -2.590381,-2.59035 0,-1.4306108 1.159753,-2.59035 2.590381,-2.59035 1.430628,0 2.590381,1.1597392 2.590381,2.59035 z"
        style={root2}
      />
      <path
        d="m 20.475416,30.840418 c 0,1.430611 -1.159753,2.59035 -2.590381,2.59035 -1.430628,0 -2.590381,-1.159739 -2.590381,-2.59035 0,-1.430611 1.159753,-2.59035 2.590381,-2.59035 1.430628,0 2.590381,1.159739 2.590381,2.59035 z"
        style={root2}
      />
      <path
        d="m 28.123341,30.840418 c 0,1.430611 -1.159753,2.59035 -2.59038,2.59035 -1.430629,0 -2.590381,-1.159739 -2.590381,-2.59035 0,-1.430611 1.159752,-2.59035 2.590381,-2.59035 1.430627,0 2.59038,1.159739 2.59038,2.59035 z"
        style={root}
      />
      <path
        d="m 12.82749,30.840418 c 0,1.430611 -1.159752,2.59035 -2.59038,2.59035 -1.4306289,0 -2.5903815,-1.159739 -2.5903815,-2.59035 0,-1.430611 1.1597526,-2.59035 2.5903815,-2.59035 1.430628,0 2.59038,1.159739 2.59038,2.59035 z"
        style={root2}
      />
      <path
        d="m 20.475416,14.819257 c 0,1.430611 -1.159753,2.59035 -2.590381,2.59035 -1.430628,0 -2.590381,-1.159739 -2.590381,-2.59035 0,-1.430611 1.159753,-2.59035 2.590381,-2.59035 1.430628,0 2.590381,1.159739 2.590381,2.59035 z"
        style={root2}
      />
      <path
        d="m 28.123341,14.819257 c 0,1.430611 -1.159753,2.59035 -2.59038,2.59035 -1.430629,0 -2.590381,-1.159739 -2.590381,-2.59035 0,-1.430611 1.159752,-2.59035 2.590381,-2.59035 1.430627,0 2.59038,1.159739 2.59038,2.59035 z"
        style={root}
      />
      <path
        d="m 12.82749,14.819257 c 0,1.430611 -1.159752,2.59035 -2.59038,2.59035 -1.4306289,0 -2.5903815,-1.159739 -2.5903815,-2.59035 0,-1.430611 1.1597526,-2.59035 2.5903815,-2.59035 1.430628,0 2.59038,1.159739 2.59038,2.59035 z"
        style={root2}
      />
      <path
        d="m 5.188928,22.88215 c 0,1.430611 -1.1597526,2.59035 -2.5903804,2.59035 -1.4306284,0 -2.59038099,-1.159739 -2.59038099,-2.59035 0,-1.430611 1.15975259,-2.59035 2.59038099,-2.59035 1.4306278,0 2.5903804,1.159739 2.5903804,2.59035 z"
        style={root}
      />
      <path
        d="m 81.375886,7.2424 c 0,1.7706961 -1.43545,3.206128 -3.206167,3.206128 -1.770717,0 -3.206166,-1.4354319 -3.206166,-3.206128 0,-1.7706956 1.435449,-3.206128 3.206166,-3.206128 1.770717,0 3.206167,1.4354325 3.206167,3.206128 z"
        style={root2}
      />
      <path
        d="m 155.8204,7.2424 c 0,1.7706961 -1.43545,3.206128 -3.20617,3.206128 -1.77072,0 -3.20617,-1.4354319 -3.20617,-3.206128 0,-1.7706956 1.43545,-3.206128 3.20617,-3.206128 1.77072,0 3.20617,1.4354325 3.20617,3.206128 z"
        style={root2}
      />
    </SvgIcon>
  );
}

export function MapMyRun(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      // width="214"
      // height="24"
      viewBox="0 0 250 40"
      {...props}
    >
      <defs>
        <radialGradient
          id="a"
          cx="93.407%"
          cy="4.944%"
          r="738.206%"
          fx="93.407%"
          fy="4.944%"
          gradientTransform="scale(-.11233 -1) rotate(-6.664 -4.54 79.436)"
        >
          <stop offset="0%" stop-color="#21C3FA" />
          <stop offset="100%" stop-color="#0076C0" />
        </radialGradient>
      </defs>
      <path
        fill="url(#a)"
        fill-rule="evenodd"
        d="M63.985 18.922V10.75l-2.027 8.172h-2.453l-2.008-8.172v8.172H53.99V4.408h4.663l2.149 9.188 2.129-9.188h4.663v14.514h-3.61zm21.343 0l-.507-2.642h-3.365l-.528 2.642h-3.851l3.73-14.514h4.926l3.568 14.514h-3.973zM83.158 7.56l-1.094 5.61h2.169l-1.074-5.61zm15.626 11.363V4.408h4.623c1.622 0 2.895.444 3.821 1.332.926.887 1.389 2.104 1.389 3.648 0 .99-.21 1.86-.629 2.613a4.454 4.454 0 0 1-1.804 1.768c-.784.427-1.703.64-2.757.64h-.831v4.513h-3.812zm4.623-7.846c1.108 0 1.662-.556 1.662-1.667s-.554-1.667-1.662-1.667h-.811v3.334h.81zm25.012 7.846V10.75l-2.027 8.172h-2.453l-2.007-8.172v8.172h-3.508V4.408h4.663l2.15 9.188 2.128-9.188h4.663v14.514h-3.609zm16.781 0v-5.346l-3.75-9.168h4.257l1.541 5.509 1.54-5.509h4.137l-3.751 9.168v5.346H145.2zm23.27 0l-1.805-4.878h-.993v4.878h-3.73V4.408h5.027c1.622 0 2.882.413 3.781 1.24s1.348 1.986 1.348 3.476c0 .786-.169 1.508-.507 2.165a4.626 4.626 0 0 1-1.44 1.657l2.454 5.976h-4.136zm-1.724-8.03c.527 0 .93-.145 1.206-.436.277-.292.416-.708.416-1.25 0-.529-.135-.936-.406-1.22-.27-.285-.662-.427-1.175-.427h-1.115v3.334h1.074zm21.951-6.484h3.974v9.026c0 1.91-.456 3.364-1.369 4.36-.912.996-2.24 1.494-3.983 1.494-1.744 0-3.072-.498-3.984-1.494-.912-.996-1.369-2.45-1.369-4.36V4.408h3.974v9.33c0 .678.108 1.173.324 1.485.217.311.568.467 1.055.467.486 0 .837-.156 1.054-.467.216-.312.324-.807.324-1.484v-9.33zm21.424 14.514l-3.487-7.297v7.297h-3.65V4.408h3.528L210 11.706V4.408h3.65v14.514h-3.528zM32.918 12c4.429 1.963 7.32 4.911 7.478 8.184 0 0-1.168.907-4.939 2.306C32.144 23.717 29.618 24 29.618 24l.011-7.288c0-1.09-.434-2.204-1.255-3.189-2.506.612-5.273.957-8.178.957h-.001c-2.903 0-5.666-.344-8.17-.955-.82.985-1.254 2.097-1.254 3.187L10.783 24s-2.526-.283-5.84-1.51c-3.77-1.4-4.938-2.307-4.938-2.307.157-3.271 3.047-6.219 7.473-8.182C3.048 10.038.158 7.09 0 3.817c0 0 1.167-.907 4.938-2.306C8.252.28 10.778 0 10.778 0l-.012 7.288c0 1.09.435 2.204 1.256 3.189 2.505-.612 5.273-.957 8.178-.957h.002c2.901 0 5.665.344 8.169.955.82-.985 1.253-2.098 1.253-3.187L29.612 0s2.526.282 5.84 1.51c3.771 1.4 4.938 2.307 4.938 2.307-.157 3.271-3.047 6.218-7.472 8.182zm-12.721 1.64l.083-.001c2.623 0 4.76-.65 6.327-1.64-1.566-.988-3.702-1.636-6.322-1.636l-.083-.001h-.004l-.082.001c-2.623 0-4.761.65-6.328 1.64 1.567.989 3.703 1.636 6.324 1.636l.081.001h.004z"
      />
    </SvgIcon>
  );
}

export function LeaderboardIcon(props) {
  let root = {
    enableBackground: "new 0 0 100 100",
  };
  return (
    <SvgIcon
      xmlns-x="http://ns.adobe.com/Extensibility/1.0/"
      xmlns-i="http://ns.adobe.com/AdobeIllustrator/10.0/"
      xmlns-graph="http://ns.adobe.com/Graphs/1.0/"
      xmlns="http://www.w3.org/2000/svg"
      xmlns-xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 100 125"
      style={root}
      xml-space="preserve"
      {...props}
    >
      <switch>
        <foreignObject
          requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"
          x="0"
          y="0"
          width="1"
          height="0"
        />
        <g i-extraneous="self">
          <g>
            <path d="M94.7,61.5H65.8V49.5c0-1.5-1.3-2.8-2.8-2.8H37c-1.5,0-2.8,1.3-2.8,2.8v11.9H5.3c-1.5,0-2.8,1.3-2.8,2.8v14.4     c0,1.5,1.3,2.8,2.8,2.8h89.4c1.5,0,2.8-1.3,2.8-2.8V64.3C97.5,62.7,96.2,61.5,94.7,61.5z" />
            <path d="M42.7,32.5c0.5,0.4,0.7,1,0.5,1.7L42,39.4c-0.3,1.4,1.2,2.6,2.5,1.8l4.6-2.8c0.5-0.3,1.2-0.3,1.7,0l4.6,2.8     c1.3,0.8,2.8-0.4,2.5-1.8l-1.3-5.3c-0.1-0.6,0.1-1.2,0.5-1.7l4.1-3.5c1.1-1,0.5-2.8-1-2.9L55,25.6c-0.6-0.1-1.2-0.4-1.4-1l-2.1-5     c-0.6-1.4-2.5-1.4-3.1,0l-2.1,5c-0.2,0.6-0.8,1-1.4,1L39.5,26c-1.5,0.1-2.1,2-1,2.9L42.7,32.5z" />
            <path d="M11,47.3c0.5,0.4,0.7,1,0.5,1.7l-1.3,5.3c-0.3,1.4,1.2,2.6,2.5,1.8l4.6-2.8c0.5-0.3,1.2-0.3,1.7,0l4.6,2.8     c1.3,0.8,2.8-0.4,2.5-1.8l-1.3-5.3c-0.1-0.6,0.1-1.3,0.5-1.7l4.1-3.5c1.1-1,0.5-2.8-1-2.9l-5.4-0.4c-0.6-0.1-1.2-0.4-1.4-1     l-2.1-5c-0.6-1.4-2.5-1.4-3.1,0l-2.1,5c-0.2,0.6-0.8,1-1.4,1l-5.4,0.4c-1.5,0.1-2.1,2-1,2.9L11,47.3z" />
            <path d="M74.4,47.3c0.5,0.4,0.7,1,0.5,1.7l-1.3,5.3c-0.3,1.4,1.2,2.6,2.5,1.8l4.6-2.8c0.5-0.3,1.2-0.3,1.7,0l4.6,2.8     c1.3,0.8,2.8-0.4,2.5-1.8l-1.3-5.3c-0.1-0.6,0.1-1.3,0.5-1.7l4.1-3.5c1.1-1,0.5-2.8-1-2.9l-5.4-0.4c-0.6-0.1-1.2-0.4-1.4-1     l-2.1-5c-0.6-1.4-2.5-1.4-3.1,0l-2.1,5c-0.2,0.6-0.8,1-1.4,1l-5.4,0.4c-1.5,0.1-2.1,2-1,2.9L74.4,47.3z" />
          </g>
        </g>
      </switch>
    </SvgIcon>
  );
}

//organizer sidebar icons
export function Participants(props) {
  return (
    <SvgIcon
      {...props}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns-xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="80.13px"
      height="80.13px"
      viewBox="0 0 80.13 80.13"
      //   style="enable-background:new 0 0 80.13 80.13;"
      xml-space="preserve"
    >
      <g>
        <path
          d="M48.355,17.922c3.705,2.323,6.303,6.254,6.776,10.817c1.511,0.706,3.188,1.112,4.966,1.112
		c6.491,0,11.752-5.261,11.752-11.751c0-6.491-5.261-11.752-11.752-11.752C53.668,6.35,48.453,11.517,48.355,17.922z M40.656,41.984
		c6.491,0,11.752-5.262,11.752-11.752s-5.262-11.751-11.752-11.751c-6.49,0-11.754,5.262-11.754,11.752S34.166,41.984,40.656,41.984
		z M45.641,42.785h-9.972c-8.297,0-15.047,6.751-15.047,15.048v12.195l0.031,0.191l0.84,0.263
		c7.918,2.474,14.797,3.299,20.459,3.299c11.059,0,17.469-3.153,17.864-3.354l0.785-0.397h0.084V57.833
		C60.688,49.536,53.938,42.785,45.641,42.785z M65.084,30.653h-9.895c-0.107,3.959-1.797,7.524-4.47,10.088
		c7.375,2.193,12.771,9.032,12.771,17.11v3.758c9.77-0.358,15.4-3.127,15.771-3.313l0.785-0.398h0.084V45.699
		C80.13,37.403,73.38,30.653,65.084,30.653z M20.035,29.853c2.299,0,4.438-0.671,6.25-1.814c0.576-3.757,2.59-7.04,5.467-9.276
		c0.012-0.22,0.033-0.438,0.033-0.66c0-6.491-5.262-11.752-11.75-11.752c-6.492,0-11.752,5.261-11.752,11.752
		C8.283,24.591,13.543,29.853,20.035,29.853z M30.589,40.741c-2.66-2.551-4.344-6.097-4.467-10.032
		c-0.367-0.027-0.73-0.056-1.104-0.056h-9.971C6.75,30.653,0,37.403,0,45.699v12.197l0.031,0.188l0.84,0.265
		c6.352,1.983,12.021,2.897,16.945,3.185v-3.683C17.818,49.773,23.212,42.936,30.589,40.741z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </SvgIcon>
  );
}

export function Execution(props) {
  return (
    <SvgIcon
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns-xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="780.648px"
      height="780.647px"
      viewBox="0 0 780.648 780.647"
      // style="enable-background:new 0 0 780.648 780.647;"
      xml-space="preserve"
      {...props}
    >
      <g>
        <g>
          <g>
            <path
              d="M533.556,23.431c-0.013-0.01-0.021-0.02-0.032-0.03c0.008-0.246,0.032-0.486,0.032-0.734
				C533.556,10.147,523.409,0,510.888,0c-11.385,0-20.806,8.393-22.421,19.327l-41.088,78.008
				c-2.261,4.195-4.483,8.408-6.661,12.646l-34.771,66.015l-5.521-19.329l11.002-21.416h-0.871h-20.42h-0.872h-20.421h-0.872
				l11.003,21.416l-5.521,19.329l-34.771-66.015c-2.177-4.238-4.398-8.451-6.66-12.646l-41.088-78.008
				C289.322,8.392,279.898,0,268.515,0c-12.519,0-22.667,10.147-22.667,22.667c0,0.248,0.025,0.489,0.033,0.734
				c-0.011,0.011-0.021,0.021-0.032,0.029c0.013,0.032,0.025,0.063,0.038,0.094c0.003,0.089,0.007,0.178,0.012,0.268
				c-0.016,0.018-0.031,0.034-0.049,0.052c0.021,0.042,0.038,0.082,0.059,0.124c0.124,2.17,0.542,4.259,1.232,6.224l0,0
				l73.23,152.873l0.47,133.205c0,0-26.865,131.494-26.865,132.729c0,17.12,13.879,31,31,31c0.114,0,0.229-0.012,0.343-0.015
				c0.179,0.004,0.354,0.015,0.53,0.015c13.357,0,24.74-8.449,29.104-20.295c1.308-2.503,2.342-5.274,3.041-8.278
				c4.289-18.443,8.482-36.912,12.758-55.361c1.361-5.304,2.716-10.606,4.027-15.927c2.396-9.706,4.681-19.438,7.003-29.164
				c2.201-7.211,4.915-14.869,7.928-24.22c3.011,9.352,5.726,17.009,7.927,24.22c2.322,9.726,4.606,19.458,7.002,29.164
				c1.313,5.317,2.665,10.623,4.027,15.927c4.272,18.449,8.47,36.918,12.759,55.361c0.698,3.004,1.73,5.775,3.04,8.278
				C428.822,471.552,440.208,480,453.567,480c0.181,0,0.354-0.011,0.532-0.015c0.112,0.003,0.227,0.015,0.341,0.015
				c17.121,0,31-13.88,31-31c0-1.235-26.864-132.729-26.864-132.729l0.471-133.205l73.229-152.872l0,0
				c0.689-1.964,1.107-4.053,1.231-6.223c0.021-0.042,0.038-0.082,0.059-0.125c-0.018-0.019-0.032-0.035-0.05-0.053
				c0.004-0.088,0.009-0.178,0.013-0.267C533.529,23.496,533.543,23.464,533.556,23.431z"
            />
            <path
              d="M389.264,117.334c0.146,0,0.291-0.011,0.438-0.012c0.146,0.001,0.29,0.012,0.438,0.012
				c24.979,0,45.229-20.25,45.229-45.229c0-24.979-20.25-45.229-45.229-45.229c-0.146,0-0.291,0.01-0.438,0.011
				c-0.146-0.001-0.289-0.011-0.438-0.011c-24.979,0-45.229,20.25-45.229,45.229C344.035,97.084,364.285,117.334,389.264,117.334z"
            />
          </g>
          <path
            d="M718.324,666.647H527.158v38.5c0,6.901-5.597,12.5-12.5,12.5s-12.5-5.599-12.5-12.5v-111.5
			c0-0.662,0.066-1.31,0.166-1.943v-76.057c0-11.047-8.954-20-20-20h-190.5c-11.046,0-20,8.953-20,20v78v4v107.5
			c0,6.901-5.597,12.5-12.5,12.5s-12.5-5.599-12.5-12.5v-107.5h-184.5c-11.046,0-20,8.953-20,20v143c0,11.045,8.954,20,20,20h381h38
			h237c11.046,0,20-8.955,20-20v-74C738.324,675.601,729.37,666.647,718.324,666.647z M403.919,673.343h-16.136V565.517h-0.371
			l-21.454,11.578l-3.229-12.705l26.956-14.438h14.234V673.343L403.919,673.343z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </SvgIcon>
  );
}
export function Setup(props) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <defs></defs>
      <g id="Layer_52" data-name="Layer 52">
        <path
          class="cls-1"
          fill="#fd6700"
          d="M32,30.15a6.77,6.77,0,0,0-6.76,6.77c.31,8.95,13.21,8.94,13.52,0A6.77,6.77,0,0,0,32,30.15Zm0,12.33c-7.35-.23-7.35-10.9,0-11.13C39.35,31.58,39.35,42.25,32,42.48Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M45.18,45.67a.64.64,0,0,0-.18-.43l-1.8-1.79a12.83,12.83,0,0,0,1.34-3.23h2.54a.6.6,0,0,0,.61-.6V34.21a.6.6,0,0,0-.61-.6H44.54a12.83,12.83,0,0,0-1.34-3.23L45,28.59a.64.64,0,0,0,.18-.43.56.56,0,0,0-.18-.42l-3.82-3.83a.61.61,0,0,0-.85,0l-1.8,1.81a12.26,12.26,0,0,0-3.22-1.34V21.83a.6.6,0,0,0-.6-.6H29.29a.6.6,0,0,0-.6.6v2.55a12.26,12.26,0,0,0-3.22,1.34l-1.8-1.81a.61.61,0,0,0-.85,0L19,27.74a.56.56,0,0,0-.18.42.64.64,0,0,0,.18.43l1.8,1.79a12.83,12.83,0,0,0-1.34,3.23H16.92a.6.6,0,0,0-.61.6v5.41a.6.6,0,0,0,.61.6h2.54a12.83,12.83,0,0,0,1.34,3.23L19,45.24a.64.64,0,0,0-.18.43.56.56,0,0,0,.18.42l3.82,3.83a.61.61,0,0,0,.85,0l1.8-1.81a12.26,12.26,0,0,0,3.22,1.34V52a.6.6,0,0,0,.6.6h5.42a.6.6,0,0,0,.6-.6V49.45a12.26,12.26,0,0,0,3.22-1.34l1.8,1.81a.61.61,0,0,0,.85,0L45,46.09A.56.56,0,0,0,45.18,45.67Zm-4.43,3s-1.84-1.88-1.85-1.8a.57.57,0,0,0-.54,0,12.27,12.27,0,0,1-3.78,1.57.62.62,0,0,0-.47.58V51.4H29.9V49c0-.06,0-.11,0-.17a.57.57,0,0,0-.39-.39,12,12,0,0,1-3.78-1.57.62.62,0,0,0-.74.08l-1.7,1.7-3-3L22,44l.09-.15a.57.57,0,0,0,0-.55,11.61,11.61,0,0,1-1.57-3.78.65.65,0,0,0-.59-.47h-2.4V34.81h2.4a.61.61,0,0,0,.57-.41,16.33,16.33,0,0,1,1.65-4.07.67.67,0,0,0-.16-.47l-1.71-1.7,3-3,1.7,1.7.1.07a.56.56,0,0,0,.61,0,12.13,12.13,0,0,1,3.76-1.56.62.62,0,0,0,.47-.58V22.43h4.2v2.41a.64.64,0,0,0,.48.58A12,12,0,0,1,38.34,27,.56.56,0,0,0,39,27l.1-.07,1.7-1.7,3,3L42,29.86a.67.67,0,0,0-.16.47,16.33,16.33,0,0,1,1.65,4.07.61.61,0,0,0,.57.41h2.4V39h-2.4l-.17,0a.62.62,0,0,0-.4.39,11.61,11.61,0,0,1-1.57,3.78A.67.67,0,0,0,42,44l1.71,1.7Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M14.65,21.12a.6.6,0,0,0,.6-.6V19a.6.6,0,0,0-.6-.6.6.6,0,0,0-.6.6v1.5A.6.6,0,0,0,14.65,21.12Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M14.65,26.83a.6.6,0,0,0,.6-.6v-1.5a.6.6,0,0,0-.6-.6.6.6,0,0,0-.6.6v1.5A.6.6,0,0,0,14.65,26.83Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M16.13,21.73a.58.58,0,0,0,.42-.18l1.06-1.05a.6.6,0,1,0-.85-.85L15.71,20.7A.61.61,0,0,0,16.13,21.73Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M16.14,22.6a.6.6,0,0,0,.6.6h1.49a.6.6,0,1,0,0-1.2H16.74A.6.6,0,0,0,16.14,22.6Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M16.76,25.56a.6.6,0,0,0,.85-.85l-1.06-1.05a.59.59,0,0,0-.84.84Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M13.6,23.66a.59.59,0,0,0-.85,0L11.7,24.71a.59.59,0,0,0,0,.85.61.61,0,0,0,.85,0l1-1.06A.58.58,0,0,0,13.6,23.66Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M11.07,23.2h1.5a.6.6,0,0,0,0-1.2h-1.5A.6.6,0,0,0,11.07,23.2Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M12.75,21.55a.6.6,0,0,0,.85-.85l-1-1.05a.6.6,0,0,0-.85.85Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M14.13,45.51c-.89,0-.53,1.25-.6,1.88a.6.6,0,0,0,.6.6c.89,0,.53-1.26.6-1.88A.6.6,0,0,0,14.13,45.51Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M14.13,50.39c-.89,0-.53,1.25-.6,1.87a.6.6,0,0,0,.6.6c.89,0,.53-1.25.6-1.87A.6.6,0,0,0,14.13,50.39Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M15,48.33c.64.61,1.27-.53,1.74-.9a.59.59,0,0,0,0-.85c-.65-.61-1.29.55-1.75.9A.6.6,0,0,0,15,48.33Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M17.18,48.57H15.91a.6.6,0,0,0,0,1.2h1.27A.6.6,0,0,0,17.18,48.57Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M15.81,50c-.54-.55-1.4.31-.85.85.27.2.95,1.13,1.33,1.08a.61.61,0,0,0,.42-1Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M12.45,50l-.91.9a.6.6,0,0,0,.85.85l.9-.9C13.85,50.31,13,49.45,12.45,50Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M13,49.17c0-.89-1.26-.53-1.88-.6a.6.6,0,0,0-.6.6c0,.89,1.26.53,1.88.6A.6.6,0,0,0,13,49.17Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M11.55,46.58c-.62.65.53,1.29.9,1.75a.58.58,0,0,0,.84,0c.62-.65-.54-1.29-.9-1.75A.6.6,0,0,0,11.55,46.58Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M49.57,21.09a.6.6,0,0,0,.6-.6V19A.6.6,0,0,0,49,19v1.49A.6.6,0,0,0,49.57,21.09Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M50.17,26.2V24.71a.6.6,0,0,0-1.2,0V26.2A.6.6,0,0,0,50.17,26.2Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M51,21.71a.6.6,0,0,0,.43-.18l1.05-1.05a.6.6,0,0,0-.85-.85l-1.05,1.05A.61.61,0,0,0,51,21.71Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M53.15,22H51.66a.6.6,0,0,0,0,1.2h1.49A.6.6,0,0,0,53.15,22Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M51.67,25.54a.6.6,0,0,0,.85-.85l-1.05-1.06c-.54-.55-1.41.31-.85.85Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M47.67,23.63l-1.06,1.06a.6.6,0,0,0,.43,1c.36.08,1.21-1,1.48-1.23C49.07,23.94,48.21,23.08,47.67,23.63Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M46,23.18h1.49a.6.6,0,0,0,0-1.2H46A.6.6,0,0,0,46,23.18Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M47.67,21.53a.6.6,0,0,0,.85-.85l-1.06-1.05c-.54-.56-1.41.3-.85.85Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M48.82,44.48a.6.6,0,0,0-.6.6v1.49a.6.6,0,0,0,1.2,0V45.08A.6.6,0,0,0,48.82,44.48Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M48.82,50.19a.6.6,0,0,0-.6.6v1.49a.6.6,0,0,0,1.2,0V50.79A.6.6,0,0,0,48.82,50.19Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M50.93,45.7l-1.06,1.06a.6.6,0,0,0,.43,1c.36.08,1.21-1,1.48-1.23C52.33,46,51.47,45.15,50.93,45.7Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M52.4,48.06H50.91a.6.6,0,0,0,0,1.2H52.4A.6.6,0,0,0,52.4,48.06Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M50.72,49.71c-.54-.55-1.41.31-.85.85.27.21,1.11,1.3,1.48,1.23a.61.61,0,0,0,.43-1Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M46.92,49.71l-1.05,1a.61.61,0,0,0,.42,1c.37.08,1.22-1,1.48-1.23C48.33,50,47.47,49.15,46.92,49.71Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M47.33,48.66a.6.6,0,0,0-.6-.6H45.24a.6.6,0,1,0,0,1.2h1.49A.6.6,0,0,0,47.33,48.66Z"
        />
        <path
          class="cls-1"
          fill="#fff"
          d="M46.72,45.7c-.55-.55-1.41.31-.85.85.27.21,1.11,1.31,1.48,1.23a.6.6,0,0,0,.42-1Z"
        />
        <path
          fill="#fff"
          d="M52.54,4.39h-3A2.4,2.4,0,0,0,47.1,3.32,2.19,2.19,0,0,0,44.91,5.5V8.39H34.47V5.5a2.3,2.3,0,0,0-2.75-2.18A2.19,2.19,0,0,0,29.54,5.5V8.39H19.09V5.5A2.19,2.19,0,0,0,16.9,3.32a2.44,2.44,0,0,0-2.43,1.07h-3A7.61,7.61,0,0,0,3.85,12V53.08a7.61,7.61,0,0,0,7.61,7.6H52.54a7.61,7.61,0,0,0,7.61-7.6V12A7.61,7.61,0,0,0,52.54,4.39ZM46.11,5.5c0-.89.81-1,1.55-1a1,1,0,0,1,1,1c0,1.75,0,5.24,0,7,0,.89-.81,1-1.55,1a1,1,0,0,1-1-1Zm-15.37,0c0-.89.8-1,1.54-1a1,1,0,0,1,1,1V9s0,0,0,0v3.48a1,1,0,0,1-1,1c-.74.06-1.51-.09-1.54-1Zm-1.2,4.09v2.89a2.3,2.3,0,0,0,2.74,2.19,2.19,2.19,0,0,0,2.19-2.19V9.59H44.91v2.89a2.31,2.31,0,0,0,2.75,2.19,2.19,2.19,0,0,0,2.19-2.19V9.59h2.69a2.4,2.4,0,0,1,2.4,2.4v4.34H9.05V12a2.41,2.41,0,0,1,2.4-2.4h2.71v2.89a2.3,2.3,0,0,0,2.74,2.19,2.19,2.19,0,0,0,2.19-2.19V9.59ZM9.05,17.53H54.94V53.08a2.4,2.4,0,0,1-2.4,2.4H11.45a2.41,2.41,0,0,1-2.4-2.4Zm6.31-12c0-.89.8-1,1.54-1a1,1,0,0,1,1,1V9a0,0,0,0,0,0,0v3.47a1,1,0,0,1-1,1c-.74.06-1.51-.09-1.54-1ZM58.94,53.08a6.41,6.41,0,0,1-6.4,6.4H11.46a6.41,6.41,0,0,1-6.4-6.4V12a6.41,6.41,0,0,1,6.4-6.4h2.7v2.8H11.45A3.6,3.6,0,0,0,7.85,12V53.08a3.61,3.61,0,0,0,3.6,3.6H52.54a3.6,3.6,0,0,0,3.6-3.6V16.94s0,0,0,0V12a3.6,3.6,0,0,0-3.6-3.6H49.85V5.59h2.69a6.41,6.41,0,0,1,6.4,6.4Z"
        />
      </g>
    </SvgIcon>
  );
}
export function Reports(props) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <path d="M58.985 6.01599H54.016V57.985H58.985V6.01599Z" />
      <path d="M36.982 32.019H32.019V57.982H36.982V32.019Z" />
      <path d="M47.985 15.016H43.016V57.985H47.985V15.016Z" />
      <path d="M14.976 38.0229H10.023V57.9761H14.976V38.0229Z" />
      <path d="M61 58H26V25H21V58H6V3C6 2.73478 5.89464 2.48043 5.70711 2.29289C5.51957 2.10536 5.26522 2 5 2C4.73478 2 4.48043 2.10536 4.29289 2.29289C4.10536 2.48043 4 2.73478 4 3V16H3C2.73478 16 2.48043 16.1054 2.29289 16.2929C2.10536 16.4804 2 16.7348 2 17C2 17.2652 2.10536 17.5196 2.29289 17.7071C2.48043 17.8946 2.73478 18 3 18H4V31H3C2.73478 31 2.48043 31.1054 2.29289 31.2929C2.10536 31.4804 2 31.7348 2 32C2 32.2652 2.10536 32.5196 2.29289 32.7071C2.48043 32.8946 2.73478 33 3 33H4V46H3C2.73478 46 2.48043 46.1054 2.29289 46.2929C2.10536 46.4804 2 46.7348 2 47C2 47.2652 2.10536 47.5196 2.29289 47.7071C2.48043 47.8946 2.73478 48 3 48H4V58H3C2.73478 58 2.48043 58.1054 2.29289 58.2929C2.10536 58.4804 2 58.7348 2 59C2 59.2652 2.10536 59.5196 2.29289 59.7071C2.48043 59.8946 2.73478 60 3 60H4V61C4 61.2652 4.10536 61.5196 4.29289 61.7071C4.48043 61.8946 4.73478 62 5 62C5.26522 62 5.51957 61.8946 5.70711 61.7071C5.89464 61.5196 6 61.2652 6 61V60H16V61C16 61.2652 16.1054 61.5196 16.2929 61.7071C16.4804 61.8946 16.7348 62 17 62C17.2652 62 17.5196 61.8946 17.7071 61.7071C17.8946 61.5196 18 61.2652 18 61V60H28V61C28 61.2652 28.1054 61.5196 28.2929 61.7071C28.4804 61.8946 28.7348 62 29 62C29.2652 62 29.5196 61.8946 29.7071 61.7071C29.8946 61.5196 30 61.2652 30 61V60H40V61C40 61.2652 40.1054 61.5196 40.2929 61.7071C40.4804 61.8946 40.7348 62 41 62C41.2652 62 41.5196 61.8946 41.7071 61.7071C41.8946 61.5196 42 61.2652 42 61V60H52V61C52 61.2652 52.1054 61.5196 52.2929 61.7071C52.4804 61.8946 52.7348 62 53 62C53.2652 62 53.5196 61.8946 53.7071 61.7071C53.8946 61.5196 54 61.2652 54 61V60H61C61.2652 60 61.5196 59.8946 61.7071 59.7071C61.8946 59.5196 62 59.2652 62 59C62 58.7348 61.8946 58.4804 61.7071 58.2929C61.5196 58.1054 61.2652 58 61 58Z" />
    </SvgIcon>
  );
}
export function Trainer(props) {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="512"
      height="512"
      enable-background="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <rect width="12" height="50.669" x="252.693" y="18.94" />
      <rect
        width="11.999"
        height="50.67"
        x="317.24"
        y="36.854"
        transform="rotate(45.001 323.263 62.2)"
      />
      <rect
        width="50.67"
        height="12"
        x="168.813"
        y="56.189"
        transform="rotate(45.001 194.15 62.189)"
      />
      <polygon points="97.688 115.042 60.496 163.506 82.221 163.506 82.221 224.402 94.221 224.402 94.221 151.506 84.832 151.506 97.688 134.753 110.545 151.506 100.997 151.506 100.997 224.402 112.997 224.402 112.997 163.506 134.88 163.506" />
      <rect width="12" height="15.244" x="82.226" y="297.901" />
      <rect width="12" height="15.245" x="82.226" y="237.411" />
      <rect width="12" height="15.246" x="82.226" y="267.655" />
      <rect width="12" height="15.246" x="101.006" y="267.655" />
      <rect width="12" height="15.245" x="101.006" y="237.411" />
      <polygon points="434.689 163.506 456.414 163.506 419.222 115.042 382.029 163.506 403.913 163.506 403.913 224.402 415.913 224.402 415.913 151.506 406.365 151.506 419.222 134.753 432.078 151.506 422.689 151.506 422.689 224.402 434.689 224.402" />
      <rect width="12" height="15.245" x="422.685" y="237.411" />
      <rect width="12" height="15.246" x="422.685" y="267.655" />
      <rect width="12" height="15.244" x="422.685" y="297.901" />
      <rect width="12" height="15.246" x="403.903" y="267.655" />
      <rect width="12" height="15.245" x="403.903" y="237.411" />
      <path d="M327.761,173.671v-7.676c0-9.467-1.864-18.649-5.541-27.295c-0.508-1.191-1.082-2.43-1.696-3.659    c-3.362-6.796-7.798-12.972-13.185-18.357c-13.175-13.175-30.688-20.431-49.312-20.431c-26.681,0-50.627,14.86-62.485,38.767    c-0.622,1.244-1.196,2.482-1.708,3.684c-3.676,8.645-5.54,17.826-5.54,27.292v7.676h12v-7.676c0-7.843,1.542-15.445,4.581-22.592    c0.416-0.975,0.887-1.99,1.409-3.036c9.826-19.809,29.653-32.114,51.743-32.114c15.419,0,29.918,6.007,40.827,16.916    c4.46,4.46,8.132,9.571,10.924,15.215c0.518,1.034,0.988,2.05,1.399,3.016c3.041,7.149,4.583,14.752,4.583,22.596v7.676H327.761z" />
      <rect width="12" height="12.567" x="252.221" y="203.604" />
      <rect width="44.468" height="12" x="308.849" y="364.325" />
      <path d="M462.087,342.957h-81.609v-24.044c0-7.266-0.657-14.574-1.952-21.719c-3.212-17.752-17.302-31.713-35.077-34.773    l-52.215-10.763v-7.042c10.479-7.909,18.063-19.46,20.851-32.755c9.414-0.541,16.913-8.345,16.913-17.888    c0-9.551-7.513-17.36-16.938-17.889c-1.401-3.833-3.972-7.138-7.448-9.387h-0.001c-5.793-3.748-10.643-16.032-12.468-20.656    c-1.415-3.585-4.519-6.2-8.303-6.996c-3.781-0.795-7.682,0.349-10.423,3.063c-19.746,19.559-47.473,24.132-58.478,25.191    c-5.332,0.513-9.642,4.04-11.349,8.805c-9.235,0.727-16.532,8.454-16.532,17.868c0,9.543,7.499,17.347,16.913,17.888    c2.844,13.559,10.676,25.297,21.479,33.216v6.604l-52.448,10.738c-17.768,3.057-31.859,17.018-35.083,34.777l-0.069,0.381    c-1.285,7.12-1.937,14.398-1.937,21.634v23.746H49.913v90.164H25.943v59.938h59.938v-59.938H61.913v-78.164h74.001v75.703h244.564    v-75.703h69.609v78.164h-23.969v59.938h59.938v-59.938h-23.97V342.957z M316.997,193.974c0,2.494-1.549,4.63-3.734,5.509v-11.018    C315.448,189.345,316.997,191.48,316.997,193.974z M73.882,445.121v35.938H37.943v-35.938h11.969v17.969h12v-17.969H73.882z     M258.031,388.186l-7.949-10.028v-23.314l16.525,12.795v9.922L258.031,388.186z M219.983,265.048l5.467-1.119v40.573l12.632-9.092    v67.606l-18.099-22.834V265.048z M250.082,318.21l16.525,12.794v21.458l-16.525-12.794V318.21z M266.607,315.828l-16.525-12.794    v-16.262l8.26-5.944l8.266,5.95V315.828z M269.111,273.795l10.122-6.35v13.635L269.111,273.795z M237.45,281.08v-13.54    l9.904,6.412L237.45,281.08z M278.607,295.415l12.626,9.087V263.91l5.566,1.147v75.096l-18.192,22.539V295.415z M199.058,193.974    c0-2.494,1.548-4.63,3.734-5.509v11.018C200.606,198.604,199.058,196.468,199.058,193.974z M214.792,200.509v-19.852    c0-0.734,0.557-1.341,1.295-1.412c15.123-1.455,43.581-7.037,65.192-28.04c3.957,9.92,9.058,20.552,16.812,25.568h-0.001    c1.957,1.266,3.172,3.618,3.172,6.14v17.596c0,23.84-19.396,43.235-43.235,43.235S214.792,224.349,214.792,200.509z     M258.027,255.744c7.511,0,14.673-1.513,21.206-4.239v1.774l-21.193,13.296l-20.59-13.33v-1.492    C243.814,254.318,250.756,255.744,258.027,255.744z M147.914,319.211c0-6.522,0.587-13.083,1.746-19.501l0.067-0.376    c2.331-12.835,12.532-22.923,25.385-25.101l32.872-6.729v76.857l44.006,55.518v18.78H147.914V319.211z M368.478,418.66H263.989    v-18.749l44.811-55.52v-76.86l32.325,6.663l0.208,0.039c12.861,2.18,23.063,12.266,25.385,25.1c1.168,6.442,1.76,13.03,1.76,19.58    V418.66z M474.057,445.121v35.938h-35.938v-35.938h11.969v17.969h12v-17.969H474.057z" />
    </SvgIcon>
  );
}
export function JobSync(props) {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000" 
      width="800px" 
      height="800px" 
      viewBox="0 0 24 24"
    >
      <path d="M19.91,15.51H15.38a1,1,0,0,0,0,2h2.4A8,8,0,0,1,4,12a1,1,0,0,0-2,0,10,10,0,0,0,16.88,7.23V21a1,1,0,0,0,2,0V16.5A1,1,0,0,0,19.91,15.51ZM12,2A10,10,0,0,0,5.12,4.77V3a1,1,0,0,0-2,0V7.5a1,1,0,0,0,1,1h4.5a1,1,0,0,0,0-2H6.22A8,8,0,0,1,20,12a1,1,0,0,0,2,0A10,10,0,0,0,12,2Z"/>
    </SvgIcon>
  );
}

export function DashboardIcon(props) {
  return (
    <SvgIcon {...props}>
      {/* Path for a classic dashboard icon: a main large square and smaller squares */}
      <path d="M13 3H21V11H13V3M13 13H21V21H13V13M3 13H11V21H3V13M3 3H11V11H3V3Z" />
    </SvgIcon>
  );
}

export function TrainingPlan(props) {
  return (
    <SvgIcon
    {...props}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 64 64"
      enable-background="new 0 0 64 64"
    >
      <path d="M60,50h-1v-2c0-1.1-0.9-2-2-2h-2c0-1.1-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v4h-3V9c0-0.6-0.4-1-1-1h-4c0-1.1-0.9-2-2-2H28.9  c-0.5-2.3-2.5-4-4.9-4s-4.4,1.7-4.9,4H9C7.9,6,7,6.9,7,8H3C2.4,8,2,8.4,2,9v52c0,0.6,0.4,1,1,1h24v-2H4V10h3v2c0,0.6,0.4,1,1,1h32  c0.6,0,1-0.4,1-1v-2h3v40h-5v-4c0-1.1-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2h-2c-1.1,0-2,0.9-2,2v2h-1c-1.1,0-2,0.9-2,2v2c0,1.1,0.9,2,2,2  h1v2c0,1.1,0.9,2,2,2h2c0,1.1,0.9,2,2,2h2c1.1,0,2-0.9,2-2v-4h5v4h-4v2h5c0.6,0,1-0.4,1-1v-5h3v4c0,1.1,0.9,2,2,2h2c1.1,0,2-0.9,2-2  h2c1.1,0,2-0.9,2-2v-2h1c1.1,0,2-0.9,2-2v-2C62,50.9,61.1,50,60,50z M39,11H9V9V8h11c0.6,0,1-0.4,1-1c0-1.7,1.3-3,3-3s3,1.3,3,3  c0,0.6,0.4,1,1,1h11v1V11z M28,54v-2h1v2H28z M31,58V48h2v10H31z M37,60h-2v-2V48v-2h2v5v4V60z M45,54h-6v-2h6h4v2H45z M51,60v-5v-4  v-5h2l0,2c0,0,0,0,0,0v10c0,0,0,0,0,0l0,2H51z M55,58V48h2l0,10H55z M60,54h-1v-2h1V54z" />
      <path d="M6,15v42c0,0.6,0.4,1,1,1h18v-2H8V15H6z" />
      <rect x="40" y="15" width="2" height="28" />
      <path d="M16,25c0.3,0,0.5-0.1,0.7-0.3l5-5l-1.4-1.4L16,22.6l-1.3-1.3l-1.4,1.4l2,2C15.5,24.9,15.7,25,16,25z" />
      <path d="M15.3,32.7c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l5-5l-1.4-1.4L16,30.6l-1.3-1.3l-1.4,1.4L15.3,32.7z" />
      <path d="M15.3,40.7c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l5-5l-1.4-1.4L16,38.6l-1.3-1.3l-1.4,1.4L15.3,40.7z" />
      <path d="M15.3,48.7c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l5-5l-1.4-1.4L16,46.6l-1.3-1.3l-1.4,1.4L15.3,48.7z" />
    </SvgIcon>
  );
}

export function SummaryDashboard(props) {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      version="1"
      viewBox="0 0 256 256"
      x="0px"
      y="0px"
    >
      <path
        d="M115 2550c-11-4-31-20-45-35l-25-27V290l32-32c30-29 40-33 103-36l70-4 1-52c0-72 18-117 58-143l34-23h851c825 0 852 1 883 20 59 35 58 29 61 474l3 408 78-75c82-80 117-96 181-82 43 9 96 58 110 101 21 62 5 108-62 180-60 64-83 75-106 52-21-21-13-38 43-97 43-45 55-65 55-89 0-44-30-72-77-72-34 0-48 11-195 158l-159 158 55 55 55 55 43-44c52-53 73-65 98-57 36 11 23 48-39 109l-59 59 20 46c25 58 48 163 48 221 0 68-25 173-59 242-29 62-29 67-33 248-2 127-7 192-16 208-23 41-71 62-139 62h-63v65c0 39-6 78-15 95-32 61-21 60-619 60H741l-12-22c-10-18-8-24 11-40 21-17 55-18 554-18 400 0 535-3 544-12 7-7 12-38 12-70v-58l-764-2-764-3-26-24c-14-14-30-41-36-60-6-23-10-392-10-998V290h-48c-91 0-82-115-80 1105l3 1080 235 5c129 3 241 9 248 13 15 10 16 39 0 55-14 14-460 16-493 2zm1923-296c21-14 22-22 22-145v-129l-47 37c-267 205-662 120-817-176-117-225-76-485 103-653 37-35 90-75 118-91 64-34 190-67 257-67 64 0 167 22 227 48l46 20 57-57 56-57V100l-24-15c-20-14-120-15-855-13-726 3-833 5-841 18-11 18-14 2139-2 2156 4 6 14 14 22 17s384 6 835 6c727 1 823-1 843-15zm-233-216c145-36 279-166 325-317 77-248-58-506-311-591-53-18-81-21-164-18-90 3-107 7-176 40-269 127-359 470-185 706 118 160 314 229 511 180z"
        transform="matrix(.1 0 0 -.1 0 256)"
      ></path>
      <path
        d="M489 2014c-9-11-10-20-2-32 9-15 38-17 263-17s254 2 263 17c8 12 7 21-2 32-12 14-47 16-261 16s-249-2-261-16zM490 1805c-6-8-9-23-5-35 6-19 13-20 265-20s259 1 265 20c15 47 0 50-265 50-204 0-250-3-260-15zM492 1598c-18-18-14-46 7-58 12-6 111-10 251-10s239 4 251 10c21 12 25 40 7 58-17 17-499 17-516 0zM490 1365c-6-8-9-23-5-35 6-19 13-20 265-20s259 1 265 20c15 47 0 50-265 50-204 0-250-3-260-15zM780 1081c-200-64-329-274-291-477 26-141 109-252 236-315 67-33 74-34 185-34 104 0 121 3 172 27l57 26 30-64 30-64h225c191 0 227 2 240 16 9 8 16 19 16 24s-7 16-16 24c-13 14-47 16-218 16h-203l-21 47-20 46 44 59c91 125 113 250 68 406l-6 22h176c181 0 216 6 216 38 0 39-17 42-230 42h-206l-39 41c-121 124-290 170-445 120zm215-66c33-9 85-33 115-53l55-37-35-3c-41-4-60-18-60-43 0-26 31-39 94-39 51 0 57-2 70-28 8-15 17-44 21-65l7-37h-184c-130 0-188-4-196-12s-12-66-12-195V320l-27 6c-64 14-153 66-197 115-66 73-89 143-84 249 6 103 31 164 99 231 53 54 87 74 161 93 70 19 102 19 173 1zm265-390c0-43-69-185-90-185-4 0-13 14-20 30-16 37-38 52-62 39-23-13-23-41 2-89l20-40-39-20c-22-11-58-24-80-29l-41-9v318h155c129 0 155-2 155-15z"
        transform="matrix(.1 0 0 -.1 0 256)"
      ></path>
      <path
        d="M1634 696c-3-8-4-23-2-33 3-16 18-18 150-21 141-2 147-2 153 18 14 43-8 50-157 50-111 0-140-3-144-14zM1642 518c-6-6-12-20-12-29 0-34 24-40 160-37 114 3 134 6 144 21 8 12 8 22 0 35-10 15-30 17-145 20-96 2-138-1-147-10zM1610 1968c-161-25-291-157-321-326-29-165 69-347 225-419 55-25 72-28 166-28 93 0 111 3 163 27 73 35 155 116 193 193 26 55 29 69 29 165 0 93-3 112-27 162-77 164-248 254-428 226zm205-99c65-31 121-88 153-158 35-75 36-182 3-257-28-63-100-136-166-166-71-33-190-32-260 2-258 125-241 496 28 592 70 25 174 20 242-13z"
        transform="matrix(.1 0 0 -.1 0 256)"
      ></path>
      <path
        d="M1777 1693c-28-26-80-74-114-106l-61-60-26 51c-29 58-38 66-66 57-30-10-25-50 18-130 54-102 57-102 212 51 72 70 130 135 130 145s-9 23-20 29c-17 9-28 4-73-37z"
        transform="matrix(.1 0 0 -.1 0 256)"
      ></path>
    </SvgIcon>
  );
}
export function Analytics(props) {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlns-xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 122.9 85.6"
      xml-space="preserve"
    >
      <g>
        <path
          class="st0"
          d="M7.5,0h107.9c4.1,0,7.5,3.4,7.5,7.5v70.6c0,4.1-3.4,7.5-7.5,7.5H7.5c-4.1,0-7.5-3.4-7.5-7.5V7.5 C0,3.4,3.4,0,7.5,0L7.5,0z M69.9,63.3h28.5v4H69.9V63.3L69.9,63.3z M69.9,53.1H109v4H69.9V53.1L69.9,53.1z M92.1,35h5.6 c0.3,0,0.5,0.2,0.5,0.5v11c0,0.3-0.2,0.5-0.5,0.5h-5.6c-0.3,0-0.5-0.2-0.5-0.5v-11C91.6,35.3,91.8,35,92.1,35L92.1,35L92.1,35z M70.5,28.3h5.6c0.3,0,0.5,0.2,0.5,0.5v17.8c0,0.3-0.2,0.5-0.5,0.5h-5.6c-0.3,0-0.5-0.2-0.5-0.5V28.8 C69.9,28.5,70.2,28.3,70.5,28.3L70.5,28.3L70.5,28.3L70.5,28.3z M81.3,24.5h5.6c0.3,0,0.5,0.2,0.5,0.5v21.6c0,0.3-0.2,0.5-0.5,0.5 h-5.6c-0.3,0-0.5-0.2-0.5-0.5V25C80.8,24.7,81,24.5,81.3,24.5L81.3,24.5L81.3,24.5z M39.3,48.2l17,0.3c0,6.1-3,11.7-8,15.1 L39.3,48.2L39.3,48.2L39.3,48.2z M37.6,45.3l-0.2-19.8l0-1.3l1.3,0.1h0h0c1.6,0.1,3.2,0.4,4.7,0.8c1.5,0.4,2.9,1,4.3,1.7 c6.9,3.6,11.7,10.8,12.1,19l0.1,1.3l-1.3,0l-19.7-0.6l-1.1,0L37.6,45.3L37.6,45.3L37.6,45.3z M39.8,26.7L40,44.1l17.3,0.5 c-0.7-6.8-4.9-12.7-10.7-15.8c-1.2-0.6-2.5-1.1-3.8-1.5C41.7,27.1,40.8,26.9,39.8,26.7L39.8,26.7L39.8,26.7z M35.9,47.2L45.6,64 c-3,1.7-6.3,2.6-9.7,2.6c-10.7,0-19.4-8.7-19.4-19.4c0-10.4,8.2-19,18.6-19.4L35.9,47.2L35.9,47.2L35.9,47.2z M115.6,14.1H7.2v64.4 h108.4V14.1L115.6,14.1L115.6,14.1z"
        />
      </g>
    </SvgIcon>
  );
}
export function EmptyEvents(props) {
  return (
    <SvgIcon
      style={{
        width: "300px",
        height: "300px",
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
      }}
      {...props}
      id="Capa_1"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 612 612"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <path
            d="m246.23 426.666h-195.039c-18.851 0-34.132-15.282-34.132-34.132v-34.134h261.957z"
            fill="#d3dcfb"
          />
          <path
            d="m460.825 153.6v143.398 95.534h-409.634c-18.851 0-34.132-15.282-34.132-34.133v-204.799l238.95-85.334z"
            fill="#ebf5fc"
          />
          <g fill="#3c58a0">
            <path d="m77.336 221.867h-18.133c-4.418 0-8-3.582-8-8v-18.133c0-4.418 3.582-8 8-8h18.133c4.418 0 8 3.582 8 8v18.133c0 4.418-3.582 8-8 8z" />
            <path d="m145.603 221.867h-18.133c-4.418 0-8-3.582-8-8v-18.133c0-4.418 3.582-8 8-8h18.133c4.418 0 8 3.582 8 8v18.133c0 4.418-3.582 8-8 8z" />
            <path d="m213.869 221.867h-18.133c-4.418 0-8-3.582-8-8v-18.133c0-4.418 3.582-8 8-8h18.133c4.418 0 8 3.582 8 8v18.133c0 4.418-3.581 8-8 8z" />
            <path d="m282.136 221.867h-18.133c-4.418 0-8-3.582-8-8v-18.133c0-4.418 3.582-8 8-8h18.133c4.418 0 8 3.582 8 8v18.133c0 4.418-3.582 8-8 8z" />
            <path d="m350.391 221.867h-18.133c-4.418 0-8-3.582-8-8v-18.133c0-4.418 3.582-8 8-8h18.133c4.418 0 8 3.582 8 8v18.133c0 4.418-3.581 8-8 8z" />
            <path d="m418.658 221.867h-18.133c-4.418 0-8-3.582-8-8v-18.133c0-4.418 3.582-8 8-8h18.133c4.418 0 8 3.582 8 8v18.133c0 4.418-3.582 8-8 8z" />
            <path d="m77.336 290.133h-18.133c-4.418 0-8-3.582-8-8v-18.133c0-4.418 3.582-8 8-8h18.133c4.418 0 8 3.582 8 8v18.133c0 4.419-3.582 8-8 8z" />
            <path d="m145.603 290.133h-18.133c-4.418 0-8-3.582-8-8v-18.133c0-4.418 3.582-8 8-8h18.133c4.418 0 8 3.582 8 8v18.133c0 4.419-3.582 8-8 8z" />
            <path d="m213.869 290.133h-18.133c-4.418 0-8-3.582-8-8v-18.133c0-4.418 3.582-8 8-8h18.133c4.418 0 8 3.582 8 8v18.133c0 4.419-3.581 8-8 8z" />
            <path d="m290.136 290.133v-25.6c0-4.713-3.82-8.533-8.533-8.533h-17.067c-4.713 0-8.533 3.82-8.533 8.533v17.067c0 4.713 3.821 8.533 8.533 8.533z" />
            <path d="m77.336 358.4h-18.133c-4.418 0-8-3.582-8-8v-18.133c0-4.418 3.582-8 8-8h18.133c4.418 0 8 3.582 8 8v18.133c0 4.418-3.582 8-8 8z" />
            <path d="m145.603 358.4h-18.133c-4.418 0-8-3.582-8-8v-18.133c0-4.418 3.582-8 8-8h18.133c4.418 0 8 3.582 8 8v18.133c0 4.418-3.582 8-8 8z" />
            <path d="m213.869 358.4h-18.133c-4.418 0-8-3.582-8-8v-18.133c0-4.418 3.582-8 8-8h18.133c4.418 0 8 3.582 8 8v18.133c0 4.418-3.581 8-8 8z" />
          </g>
          <path
            d="m418.417 187.733h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.219 4.178 5.219 7.662v17.65c0 3.484-2.165 6.456-5.219 7.662.937.37 1.954.58 3.022.58h17.65c4.552 0 8.242-3.69 8.242-8.241v-17.65c-.001-4.552-3.691-8.242-8.242-8.242z"
            fill="#2a428c"
          />
          <path
            d="m350.15 187.733h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.219 4.178 5.219 7.662v17.65c0 3.484-2.165 6.456-5.219 7.662.937.37 1.954.58 3.022.58h17.65c4.552 0 8.241-3.69 8.241-8.241v-17.65c0-4.552-3.689-8.242-8.241-8.242z"
            fill="#2a428c"
          />
          <path
            d="m281.895 187.733h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.65c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h17.65c4.552 0 8.242-3.69 8.242-8.241v-17.65c-.001-4.552-3.691-8.242-8.242-8.242z"
            fill="#2a428c"
          />
          <path
            d="m213.628 187.733h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.65c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h17.65c4.552 0 8.242-3.69 8.242-8.241v-17.65c-.001-4.552-3.69-8.242-8.242-8.242z"
            fill="#2a428c"
          />
          <path
            d="m145.361 187.733h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.219 4.178 5.219 7.662v17.65c0 3.484-2.165 6.456-5.219 7.662.937.37 1.954.58 3.022.58h17.65c4.552 0 8.242-3.69 8.242-8.241v-17.65c0-4.552-3.69-8.242-8.242-8.242z"
            fill="#2a428c"
          />
          <path
            d="m77.095 187.733h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.65c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h17.65c4.552 0 8.242-3.69 8.242-8.241v-17.65c-.001-4.552-3.691-8.242-8.242-8.242z"
            fill="#2a428c"
          />
          <path
            d="m77.095 256h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.651c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h17.65c4.552 0 8.242-3.69 8.242-8.241v-17.651c-.001-4.552-3.691-8.242-8.242-8.242z"
            fill="#2a428c"
          />
          <path
            d="m77.095 324.267h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.651c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h17.65c4.552 0 8.242-3.69 8.242-8.241v-17.651c-.001-4.553-3.691-8.242-8.242-8.242z"
            fill="#2a428c"
          />
          <path
            d="m145.361 256h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.219 4.178 5.219 7.662v17.651c0 3.484-2.165 6.456-5.219 7.662.937.37 1.954.58 3.022.58h17.65c4.552 0 8.242-3.69 8.242-8.241v-17.651c0-4.552-3.69-8.242-8.242-8.242z"
            fill="#2a428c"
          />
          <path
            d="m145.361 324.267h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.219 4.178 5.219 7.662v17.651c0 3.484-2.165 6.456-5.219 7.662.937.37 1.954.58 3.022.58h17.65c4.552 0 8.242-3.69 8.242-8.241v-17.651c0-4.553-3.69-8.242-8.242-8.242z"
            fill="#2a428c"
          />
          <path
            d="m213.628 256h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.651c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h17.65c4.552 0 8.242-3.69 8.242-8.241v-17.651c-.001-4.552-3.69-8.242-8.242-8.242z"
            fill="#2a428c"
          />
          <path
            d="m290.136 290.133v-25.892c0-4.552-3.69-8.241-8.242-8.241h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.651c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h25.892z"
            fill="#2a428c"
          />
          <path
            d="m213.628 324.267h-17.65c-1.068 0-2.085.21-3.022.579 3.055 1.206 5.22 4.178 5.22 7.662v17.651c0 3.484-2.165 6.456-5.22 7.662.937.37 1.954.58 3.022.58h17.65c4.552 0 8.242-3.69 8.242-8.241v-17.651c-.001-4.553-3.69-8.242-8.242-8.242z"
            fill="#2a428c"
          />
          <path
            d="m437.114 143.721v153.277 95.535h23.711v-95.535-143.398z"
            fill="#d3dcfb"
          />
          <path
            d="m460.825 153.6v-85.334c0-18.851-15.282-34.132-34.132-34.132h-375.502c-18.851 0-34.132 15.281-34.132 34.132v85.334z"
            fill="#ff4155"
          />
          <g>
            <g>
              <g>
                <path
                  d="m124.609 75.993h-22.217c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h22.217c4.268 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z"
                  fill="#e80054"
                />
              </g>
              <g>
                <path
                  d="m179.191 75.993h-22.217c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h22.217c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z"
                  fill="#e80054"
                />
              </g>
              <g>
                <path
                  d="m320.887 75.993h-22.218c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h22.218c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z"
                  fill="#e80054"
                />
              </g>
              <g>
                <path
                  d="m375.47 75.993h-22.218c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h22.218c4.268 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z"
                  fill="#e80054"
                />
              </g>
            </g>
          </g>
          <path
            d="m162.125 64c0 11.782-9.551 21.333-21.333 21.333s-21.333-9.551-21.333-21.333v-42.667c-.001-11.782 9.55-21.333 21.332-21.333s21.333 9.551 21.333 21.333v42.667z"
            fill="#ebf5fc"
          />
          <path
            d="m358.403 64c0 11.782-9.551 21.333-21.333 21.333s-21.334-9.551-21.334-21.333v-42.667c0-11.782 9.551-21.333 21.333-21.333s21.333 9.551 21.333 21.333v42.667z"
            fill="#ebf5fc"
          />
          <path
            d="m337.069 0c-4.38 0-8.448 1.324-11.836 3.588 5.725 3.826 9.498 10.343 9.498 17.746v42.666c0 7.402-3.773 13.92-9.498 17.746 3.387 2.263 7.456 3.588 11.836 3.588 11.782 0 21.333-9.551 21.333-21.333v-42.668c.001-11.782-9.55-21.333-21.333-21.333z"
            fill="#d3dcfb"
          />
          <path
            d="m140.791 0c-4.38 0-8.448 1.324-11.836 3.588 5.725 3.826 9.498 10.343 9.498 17.746v42.666c0 7.402-3.773 13.92-9.498 17.746 3.387 2.263 7.456 3.588 11.836 3.588 11.782 0 21.333-9.551 21.333-21.333v-42.668c.001-11.782-9.55-21.333-21.333-21.333z"
            fill="#d3dcfb"
          />
          <path
            d="m426.693 34.133h-23.703c18.851 0 34.132 15.281 34.132 34.132v85.335h23.702v-85.334c.001-18.851-15.281-34.133-34.131-34.133z"
            fill="#e80054"
          />
          <path d="m17.058 111.74h443.767v15.453h-443.767z" fill="#e80054" />
        </g>
        <circle cx="366.942" cy="384" fill="#4fabf7" r="128" />
        <circle cx="366.942" cy="384" fill="#ebf5fc" r="93.867" />
        <g>
          <g>
            <path
              d="m366.942 374.659c-4.268 0-7.726-3.459-7.726-7.726v-42.667c0-4.267 3.459-7.726 7.726-7.726 4.268 0 7.726 3.459 7.726 7.726v42.667c0 4.267-3.459 7.726-7.726 7.726z"
              fill="#3c58a0"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="m409.609 391.726h-25.601c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h25.601c4.268 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z"
              fill="#3c58a0"
            />
          </g>
        </g>
        <path
          d="m366.942 256c-3.995 0-7.945.193-11.847.551 65.137 5.979 116.152 60.752 116.152 127.449s-51.016 121.47-116.153 127.449c3.902.358 7.852.551 11.847.551 70.692 0 128-57.308 128-128s-57.307-128-127.999-128z"
          fill="#1886ea"
        />
        <path
          d="m366.942 290.133c-4.01 0-7.961.253-11.839.741 46.252 5.821 82.028 45.295 82.028 93.126s-35.776 87.305-82.028 93.126c3.878.488 7.829.741 11.839.741 51.841 0 93.867-42.026 93.867-93.867s-42.026-93.867-93.867-93.867z"
          fill="#d3dcfb"
        />
        <circle cx="366.942" cy="384" fill="#ffdd40" r="17.067" />
      </g>
    </SvgIcon>
  );
}

export function GoogleFitIcon(props) {
  return (
    <SvgIcon
      {...props}
      xmlns-x="http://ns.adobe.com/Extensibility/1.0/"
      xmlns-i="http://ns.adobe.com/AdobeIllustrator/10.0/"
      xmlns-graph="http://ns.adobe.com/Graphs/1.0/"
      xmlns="http://www.w3.org/2000/svg"
      xmlns-xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 236.2 200"
      enable-background="new 0 0 236.2 200"
      xml-space="preserve"
    >
      <metadata>
        <sfw xmlns="http://ns.adobe.com/SaveForWeb/1.0/">
          <slices />
          <sliceSourceBounds
            bottomLeftOrigin="true"
            height="200"
            width="236.2"
            x="338.3"
            y="-779.5"
          />
        </sfw>
      </metadata>
      <g>
        <path
          fill="#EA4335"
          d="M22.6,105.8l11.9,11.9l25.7-25.6L48.4,80.2l0,0L43,74.8c-4.3-4.3-6.6-9.9-6.6-16c0-5.3,1.8-10.1,4.9-13.9   l0,0l0,0l0,0l0,0c4.2-5.3,10.6-8.7,17.8-8.7c6.1,0,11.7,2.4,16.1,6.7l5.3,5.1L92.4,60l25.8-25.6l-12-11.9l-5.4-5.2   C90.1,6.6,75.4,0,59.1,0C26.4,0,0,26.4,0,58.9C0,67,1.6,74.7,4.6,81.8c3,7.1,7.3,13.4,12.7,18.7L22.6,105.8"
        />
        <polyline
          fill="#FBBC04"
          points="81.5,122.2 118.2,85.7 92.4,60 60.2,92.1 60.2,92.1 34.5,117.7 48.3,131.6 60.2,143.4 72.6,131     "
        />
        <polygon
          fill="#34A853"
          points="143.8,175.6 201.8,117.7 176,92.1 118.1,149.9 85.9,117.8 60.2,143.4 92.4,175.6 92.3,175.7    118.1,200 118.1,200 118.1,200 143.9,175.6 143.9,175.6  "
        />
        <path
          fill="#4285F4"
          d="M218.9,100.5c12-12,18.9-30.4,17-49c-2.8-28.2-26.2-49.4-54.6-51.3c-17.9-1.2-34.3,5.5-45.9,17.1L92.4,60   l25.7,25.7l43-42.8c5.2-5.1,12.4-7.5,19.8-6.3c9.6,1.5,17.4,9.4,18.7,19c1,7.2-1.4,14.2-6.5,19.3L176,92.1l25.8,25.6L218.9,100.5z"
        />
      </g>
    </SvgIcon>
  );
}
export function GoogleFitText(props) {
  return (
    <SvgIcon
      {...props}
      class="devsite-google-wordmark"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 148 48"
    >
      <title>Google</title>
      <path
        class="devsite-google-wordmark-svg-path"
        d="M19.58,37.65c-9.87,0-18.17-8.04-18.17-17.91c0-9.87,8.3-17.91,18.17-17.91c5.46,0,9.35,2.14,12.27,4.94l-3.45,3.45c-2.1-1.97-4.93-3.49-8.82-3.49c-7.21,0-12.84,5.81-12.84,13.02c0,7.21,5.64,13.02,12.84,13.02c4.67,0,7.34-1.88,9.04-3.58c1.4-1.4,2.32-3.41,2.66-6.16H19.58v-4.89h16.47c0.18,0.87,0.26,1.92,0.26,3.06c0,3.67-1.01,8.21-4.24,11.44C28.93,35.9,24.91,37.65,19.58,37.65z M61.78,26.12c0,6.64-5.1,11.53-11.36,11.53s-11.36-4.89-11.36-11.53c0-6.68,5.1-11.53,11.36-11.53S61.78,19.43,61.78,26.12z M56.8,26.12c0-4.15-2.96-6.99-6.39-6.99c-3.43,0-6.39,2.84-6.39,6.99c0,4.11,2.96,6.99,6.39,6.99C53.84,33.11,56.8,30.22,56.8,26.12z M87.25,26.12c0,6.64-5.1,11.53-11.36,11.53c-6.26,0-11.36-4.89-11.36-11.53c0-6.68,5.1-11.53,11.36-11.53C82.15,14.59,87.25,19.43,87.25,26.12zM82.28,26.12c0-4.15-2.96-6.99-6.39-6.99c-3.43,0-6.39,2.84-6.39,6.99c0,4.11,2.96,6.99,6.39,6.99C79.32,33.11,82.28,30.22,82.28,26.12z M112.09,15.29v20.7c0,8.52-5.02,12.01-10.96,12.01c-5.59,0-8.95-3.76-10.22-6.81l4.41-1.83c0.79,1.88,2.71,4.1,5.81,4.1c3.8,0,6.16-2.36,6.16-6.77v-1.66h-0.18c-1.14,1.4-3.32,2.62-6.07,2.62c-5.76,0-11.05-5.02-11.05-11.49c0-6.51,5.28-11.57,11.05-11.57c2.75,0,4.93,1.22,6.07,2.58h0.18v-1.88H112.09z M107.64,26.16c0-4.06-2.71-7.03-6.16-7.03c-3.49,0-6.42,2.97-6.42,7.03c0,4.02,2.93,6.94,6.42,6.94C104.93,33.11,107.64,30.18,107.64,26.16z M120.97,3.06v33.89h-5.07V3.06H120.97z M140.89,29.92l3.93,2.62c-1.27,1.88-4.32,5.11-9.61,5.11c-6.55,0-11.28-5.07-11.28-11.53c0-6.86,4.77-11.53,10.71-11.53c5.98,0,8.91,4.76,9.87,7.34l0.52,1.31l-15.42,6.38c1.18,2.31,3.01,3.49,5.59,3.49C137.79,33.11,139.58,31.84,140.89,29.92zM128.79,25.77l10.31-4.28c-0.57-1.44-2.27-2.45-4.28-2.45C132.24,19.04,128.66,21.31,128.79,25.77z"
      ></path>
    </SvgIcon>
  );
}
export function NoActivityAvailable(props) {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlns-xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      // width="524.33px"
      // height="524.33px"
      viewBox="0 0 224.33 224.33"
      // style="enable-background:new 0 0 224.33 224.33;"
      xml-space="preserve"
    >
      <g>
        <path
          color="#696969"
          d="M187.744,119.241c0.67-31.958-24.781-58.503-56.731-59.179c-31.956-0.675-58.506,24.773-59.182,56.727   c-0.01,0.538,0.041,1.035,0.046,1.574h-0.005c0,0.162,0.02,0.324,0.02,0.497c0.021,1.635,0.089,3.28,0.251,4.885   c0.076,0.854,0.218,1.696,0.333,2.539c0.134,0.944,0.249,1.879,0.432,2.793c0.061,0.33,0.086,0.66,0.15,0.98   c0.025,0,0.051,0,0.083,0c0.681,3.199,1.569,6.316,2.755,9.303c-0.036,0-0.079,0-0.114,0c1.627,4.164,3.75,8.079,6.246,11.71   c0.083,0,0.16,0,0.249,0c5.543,7.937,13.01,14.426,21.762,18.783c-0.223,0-0.452,0-0.675,0c6.962,3.585,14.731,5.799,22.988,6.286   c0.011-0.102,0-0.233,0-0.34c0.741,0.046,1.463,0.143,2.214,0.162c6.957,0.138,13.619-1,19.855-3.133v0.346   c5.017-1.706,9.739-4.062,14.035-7.019v-0.365C177.353,155.604,187.327,138.644,187.744,119.241z M128.859,161.414   c-20.439-0.427-37.275-15.011-41.457-34.154c-0.135-0.65-0.294-1.29-0.399-1.94c-0.114-0.7-0.193-1.411-0.276-2.112   c-0.165-1.513-0.302-3.036-0.308-4.601c-0.005-0.508-0.056-0.995-0.045-1.513c0.041-2.021,0.269-4.002,0.582-5.952   c0.02,0,0.038,0,0.058,0c0.696-4.131,1.965-8.056,3.738-11.702c-0.056,0-0.12,0-0.175,0c7.117-14.965,22.503-25.202,40.111-24.829   c6.348,0.135,12.329,1.666,17.712,4.233v0.345c5.393,2.577,10.156,6.233,14.046,10.685V89.53   c6.86,7.868,10.963,18.169,10.729,29.401C172.671,142.864,152.787,161.926,128.859,161.414z M224.33,206.115l-13.086,12.543   l-43.579-45.463l13.081-12.543L224.33,206.115z M66.354,62.162c-10.087,0-20.175,0-30.267,0c-7.274,0-7.274-11.705,0-11.705   c10.092,0,20.18,0,30.267,0C73.633,50.457,73.633,62.162,66.354,62.162z M36.087,81.085c-7.274,0-7.274-11.705,0-11.705   c10.092,0,20.18,0,30.267,0c7.274,0,7.274,11.705,0,11.705C56.267,81.085,46.184,81.085,36.087,81.085z M162.455,98.629v39.374   c-3.442,5.668-8.287,10.37-14.04,13.63V85.025C154.198,88.27,159.027,92.983,162.455,98.629z M148.415,178.678   c4.971-1.554,9.663-3.772,14.04-6.448v44.401H0V5.672h132.271l30.184,29.27v29.432c-4.418-2.684-9.12-4.827-14.04-6.345V42.007   h-23.38V19.715H14.043v182.87h134.371V178.678z M120.958,151.07c-1.889,0-5.748,0-10.841,0c-4.898-2.95-9.084-6.957-12.225-11.71   c10.96,0,19.857,0,23.071,0C128.229,139.365,128.229,151.07,120.958,151.07z M34.505,139.365c4.385,0,19.375,0,35.749,0   c1.435,4.083,3.28,8.003,5.548,11.71c-18.428,0-36.419,0-41.297,0C27.236,151.07,27.236,139.365,34.505,139.365z M120.958,130.067   c-3.626,0-14.559,0-27.518,0c-1.196-3.696-1.846-7.627-1.846-11.71c13.759,0,25.555,0,29.358,0   C128.229,118.357,128.229,130.067,120.958,130.067z M34.505,118.357c4.062,0,17.222,0,32.156,0   c-0.005,3.966,0.338,7.887,1.056,11.71c-15.366,0-29.059,0-33.212,0C27.236,130.067,27.236,118.357,34.505,118.357z    M120.958,111.152c-3.747,0-15.208,0-28.66,0c0.81-4.182,2.293-8.128,4.357-11.708c11.522,0,20.972,0,24.303,0   C128.229,99.444,128.229,111.152,120.958,111.152z M34.505,99.444c4.322,0,18.964,0,35.074,0c-1.201,3.77-2.064,7.68-2.531,11.708   c-15.097,0-28.444,0-32.542,0C27.236,111.152,27.236,99.444,34.505,99.444z M90.69,181.573c-7.274,0-7.274-11.699,0-11.699   c0.858,0,1.716,0,2.574,0c8.77,6.256,18.951,10.115,29.754,11.263c-0.604,0.244-1.279,0.437-2.057,0.437   C110.865,181.573,100.783,181.573,90.69,181.573z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </SvgIcon>
  );
}

export function NoLeaderboard(props) {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      enable-background="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <g>
            <path
              color="gray"
              d="m489.536 219.221c-1.813-3.605-5.504-5.888-9.536-5.888h-96v21.333h113.259z"
            />
            <path
              color="gray"
              d="m340.203 69.888c-1.813-3.605-5.504-5.888-9.536-5.888h-149.334c-4.032 0-7.723 2.283-9.536 5.888l-7.723 15.445h183.851z"
            />
            <path
              color="gray"
              d="m511.509 264.213c-.171-.683-.256-1.365-.533-1.984-1.685-3.648-5.355-6.229-9.643-6.229h-138.666v-138.667c0-.875-.299-1.643-.491-2.453-.171-.683-.256-1.365-.533-1.984-1.685-3.648-5.355-6.229-9.643-6.229h-192c-4.288 0-7.936 2.581-9.643 6.229-.277.619-.384 1.301-.533 1.984-.192.811-.491 1.579-.491 2.453v117.333h-138.666c-4.288 0-7.936 2.581-9.643 6.229-.277.619-.384 1.301-.533 1.984-.192.812-.491 1.58-.491 2.454v192c0 5.867 4.779 10.667 10.667 10.667h490.667c5.888 0 10.667-4.8 10.667-10.667v-170.666c-.001-.875-.3-1.643-.492-2.454zm-404.842 98.432v.021c5.888 0 10.667 4.779 10.667 10.667s-4.779 10.667-10.667 10.667h-42.667c-4.309 0-8.213-2.603-9.856-6.592-1.664-3.989-.747-8.576 2.304-11.627l27.584-27.584c7.701-7.722 11.968-17.984 11.968-28.885 0-5.867-4.779-10.667-10.667-10.667s-10.667 4.8-10.667 10.667c0 5.888-4.779 10.667-10.667 10.667s-10.667-4.779-10.667-10.667c0-17.643 14.357-32 32-32s32 14.357 32 32c0 16.576-6.464 32.213-18.219 43.968l-9.365 9.365zm170.688-74.645h-.021c0 5.888-4.779 10.667-10.667 10.667s-10.667-4.779-10.667-10.667v-80.917l-3.115 3.115c-4.16 4.16-10.923 4.16-15.083 0s-4.16-10.923 0-15.083l21.333-21.333c3.051-3.072 7.637-3.968 11.627-2.304 3.989 1.643 6.592 5.547 6.592 9.856v106.666zm181.312 85.333c0 17.643-14.357 32-32 32s-32-14.357-32-32c0-5.888 4.779-10.667 10.667-10.667s10.667 4.779 10.667 10.667c-.001 5.867 4.778 10.667 10.666 10.667s10.667-4.8 10.667-10.667-4.779-10.667-10.667-10.667-10.667-4.778-10.667-10.666 4.779-10.667 10.667-10.667 10.667-4.8 10.667-10.667-4.779-10.667-10.667-10.667-10.667 4.801-10.667 10.668c0 5.888-4.779 10.667-10.667 10.667s-10.667-4.779-10.667-10.667c0-17.643 14.357-32 32-32s32 14.357 32 32c0 8.192-3.093 15.659-8.171 21.333 5.078 5.675 8.172 13.141 8.172 21.333z"
            />
            <path
              color="gray"
              d="m128 192h-96c-4.032 0-7.723 2.283-9.536 5.888l-7.723 15.445h113.259z"
            />
          </g>
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </SvgIcon>
  );
}

export function RuppeeIcon(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      xmlns-xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      width="401.998px"
      height="401.998px"
      viewBox="0 0 401.998 401.998"
      // style="enable-background:new 0 0 401.998 401.998;"
      xml-space="preserve"
      {...props}
    >
      <g>
        <path d="M326.62,91.076c-1.711-1.713-3.901-2.568-6.563-2.568h-48.82c-3.238-15.793-9.329-29.502-18.274-41.112h66.52   c2.669,0,4.853-0.856,6.57-2.565c1.704-1.712,2.56-3.903,2.56-6.567V9.136c0-2.666-0.855-4.853-2.56-6.567   C324.334,0.859,322.15,0,319.481,0H81.941c-2.666,0-4.853,0.859-6.567,2.568c-1.709,1.714-2.568,3.901-2.568,6.567v37.972   c0,2.474,0.904,4.615,2.712,6.423s3.949,2.712,6.423,2.712h41.399c40.159,0,65.665,10.751,76.513,32.261H81.941   c-2.666,0-4.856,0.855-6.567,2.568c-1.709,1.715-2.568,3.901-2.568,6.567v29.124c0,2.664,0.855,4.854,2.568,6.563   c1.714,1.715,3.905,2.568,6.567,2.568h121.915c-4.188,15.612-13.944,27.506-29.268,35.691   c-15.325,8.186-35.544,12.279-60.67,12.279H81.941c-2.474,0-4.615,0.905-6.423,2.712c-1.809,1.809-2.712,3.951-2.712,6.423v36.263   c0,2.478,0.855,4.571,2.568,6.282c36.543,38.828,83.939,93.165,142.182,163.025c1.715,2.286,4.093,3.426,7.139,3.426h55.672   c4.001,0,6.763-1.708,8.281-5.141c1.903-3.426,1.53-6.662-1.143-9.708c-55.572-68.143-99.258-119.153-131.045-153.032   c32.358-3.806,58.625-14.277,78.802-31.404c20.174-17.129,32.449-39.403,36.83-66.811h47.965c2.662,0,4.853-0.854,6.563-2.568   c1.715-1.709,2.573-3.899,2.573-6.563V97.646C329.193,94.977,328.335,92.79,326.62,91.076z" />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </SvgIcon>
  );
}

export function HomeIcon(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width ? props.width : "256"}
      height={props?.height ? props.height : "256"}
      viewBox="0 0 256 256"
    >
      <g
        fill={props?.color ? props.color : "#000"}
        strokeMiterlimit="10"
        strokeWidth="0"
      >
        <path
          d="M45 1.5L1.5 35.137h10.888V88.5H33.14V62.269c0-4.221 3.337-7.674 7.416-7.674h8.889c4.079 0 7.416 3.453 7.416 7.674V88.5h20.752V35.137H88.5L45 1.5z"
          transform="matrix(.72 0 0 .72 128 128) matrix(3.89 0 0 3.89 -175.05 -175.05)"
        ></path>
        <path
          d="M77.612 90H56.86a1.5 1.5 0 01-1.5-1.5V62.27c0-3.405-2.654-6.175-5.916-6.175h-8.889c-3.262 0-5.917 2.77-5.917 6.175V88.5a1.5 1.5 0 01-1.5 1.5h-20.75a1.5 1.5 0 01-1.5-1.5V36.637H1.5a1.499 1.499 0 01-.917-2.686L44.083.314a1.5 1.5 0 011.835 0l43.5 33.637a1.501 1.501 0 01-.918 2.686h-9.388V88.5a1.5 1.5 0 01-1.5 1.5zM58.36 87h17.752V35.137a1.5 1.5 0 011.5-1.5h6.496L45 3.396 5.892 33.637h6.496a1.5 1.5 0 011.5 1.5V87h17.751V62.27c0-5.059 4-9.175 8.917-9.175h8.889c4.916 0 8.916 4.116 8.916 9.175V87z"
          transform="matrix(.72 0 0 .72 128 128) matrix(3.89 0 0 3.89 -175.05 -175.05)"
        ></path>
      </g>
    </SvgIcon>
  );
}

export function VideoPlayerIcon(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      width="82"
      height="100"
      imageRendering="optimizeQuality"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      viewBox="0 0 500 500"
      {...props}
    >
      <g>
        <rect
          width="460"
          height="340"
          x="20"
          y="80"
          className="fil0"
          rx="45"
          ry="45"
        ></rect>
        <path
          d="M65 80h185v340H65c-25 0-45-20-45-45V125c0-25 20-45 45-45z"
          className="fil1"
        ></path>
        <path
          d="M333 242l-65-37-65-38c-3-1-6-1-9 0-3 2-4 5-4 8v150c0 3 1 6 4 8 3 1 6 1 9 0l65-38 65-37c3-2 4-5 4-8s-1-6-4-8z"
          className="fil2"
        ></path>
        <path
          d="M60 120h50v50H60v-50zm0 70h50v50H60v-50zm0 70h50v50H60v-50zm0 70h50v50H60v-50zm331-210h50v50h-50v-50zm0 70h50v50h-50v-50zm0 70h50v50h-50v-50zm0 70h50v50h-50v-50z"
          className="fil3"
        ></path>
      </g>
    </SvgIcon>
  );
}

export function NoGoodieGenerated(props) {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      id="icon"
    >
      <title>no-image</title>
      <path d="M30,3.4141,28.5859,2,2,28.5859,3.4141,30l2-2H26a2.0027,2.0027,0,0,0,2-2V5.4141ZM26,26H7.4141l7.7929-7.793,2.3788,2.3787a2,2,0,0,0,2.8284,0L22,19l4,3.9973Zm0-5.8318-2.5858-2.5859a2,2,0,0,0-2.8284,0L19,19.1682l-2.377-2.3771L26,7.4141Z"/>
      <path d="M6,22V19l5-4.9966,1.3733,1.3733,1.4159-1.416-1.375-1.375a2,2,0,0,0-2.8284,0L6,16.1716V6H22V4H6A2.002,2.002,0,0,0,4,6V22Z"/>
      <rect
        id="_Transparent_Rectangle_"
        data-name="&lt;Transparent Rectangle&gt;"
        class="cls-1"
        fill="none"
        width="32"
        height="32"
      />
      </SvgIcon>
  );
}
export function Crown(props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="728" height="366" viewBox="0 0 728 366" fill="none">
   <g xmlns="http://www.w3.org/2000/svg" transform="translate(0.000000,151.000000) scale(0.100000,-0.100000)" fill="#f2a131" stroke="none"> <path d="M1480 1255 c-7 -19 -17 -25 -39 -25 -40 0 -45 -13 -16 -40 19 -18 22 -29 18 -56 -6 -38 2 -42 35 -18 20 14 24 14 44 0 33 -24 41 -20 35 18 -4 27 -1 38 19 55 30 26 23 41 -17 41 -22 0 -32 6 -39 25 -5 14 -14 25 -20 25 -6 0 -15 -11 -20 -25z m33 -25 c4 -14 14 -20 33 -20 l28 0 -22 -20 c-18 -17 -20 -25 -11 -46 9 -27 9 -27 -16 -10 -23 15 -27 15 -50 0 -25 -17 -25 -17 -16 10 9 21 7 29 -11 46 l-22 20 28 0 c19 0 29 6 33 20 3 11 9 20 13 20 4 0 10 -9 13 -20z"/> <path d="M1211 1120 c-8 -24 -16 -30 -40 -30 -36 0 -42 -23 -11 -40 17 -9 20 -17 14 -46 -7 -37 0 -41 41 -22 19 9 28 9 37 0 11 -11 48 -17 48 -8 0 3 -4 16 -9 29 -8 20 -5 29 14 47 29 27 24 40 -15 40 -22 0 -30 6 -39 30 -5 17 -14 30 -20 30 -5 0 -14 -13 -20 -30z m69 -50 c22 -5 23 -7 6 -13 -14 -5 -17 -15 -14 -37 5 -32 -1 -37 -20 -18 -9 9 -18 9 -38 -1 -25 -11 -26 -10 -21 11 4 13 0 29 -9 39 -13 15 -13 17 9 23 14 3 27 16 31 28 l6 23 13 -25 c6 -13 23 -27 37 -30z"/> <path d="M1757 1120 c-9 -25 -17 -30 -44 -30 -38 0 -44 -19 -12 -38 17 -11 20 -20 15 -48 -6 -29 -4 -34 12 -34 10 0 23 5 30 12 9 9 18 9 37 0 41 -19 48 -15 41 22 -6 29 -3 37 14 46 31 17 25 40 -11 40 -24 0 -32 6 -40 30 -6 17 -15 30 -21 30 -5 0 -15 -13 -21 -30z m59 -46 c23 -6 24 -8 9 -24 -11 -12 -14 -26 -10 -39 6 -20 4 -20 -20 -9 -19 9 -28 9 -37 0 -19 -19 -26 -14 -20 13 3 18 -1 30 -14 40 -18 14 -18 14 4 15 17 0 27 9 35 30 l12 31 8 -26 c5 -14 19 -28 33 -31z"/> <path d="M1424 938 c-30 -28 -35 -40 -36 -77 -1 -75 54 -126 127 -117 95 11 131 126 60 194 -27 25 -43 32 -75 32 -32 0 -48 -7 -76 -32z m141 -12 c48 -48 40 -122 -16 -151 -54 -29 -117 -8 -139 44 -26 64 20 131 90 131 30 0 47 -6 65 -24z"/> <path d="M1232 895 c-38 -17 -63 -66 -55 -108 7 -36 57 -77 93 -77 36 0 87 42 95 79 16 75 -61 137 -133 106z m71 -16 c49 -22 61 -86 22 -124 -44 -45 -115 -22 -131 40 -7 30 17 72 49 85 30 12 32 12 60 -1z"/> <path d="M1690 892 c-67 -33 -76 -108 -18 -157 38 -32 78 -32 116 0 56 47 44 133 -22 160 -43 18 -34 18 -76 -3z m64 -12 c14 -5 32 -21 42 -34 43 -67 -46 -148 -113 -101 -43 30 -37 110 10 133 28 14 31 14 61 2z"/> <path d="M1394 691 c-45 -21 -77 -56 -96 -107 -6 -19 -18 -34 -26 -34 -19 0 -8 44 24 92 13 21 24 40 24 44 0 3 -29 4 -65 2 -73 -4 -108 -24 -140 -79 -16 -27 -20 -57 -23 -161 -3 -92 -1 -132 8 -143 11 -13 69 -15 406 -15 l394 0 6 26 c4 14 5 78 2 143 -3 93 -8 124 -23 151 -32 54 -67 74 -140 78 -36 2 -65 1 -65 -2 0 -4 11 -23 24 -44 32 -48 43 -92 24 -92 -8 0 -20 15 -26 34 -31 85 -96 126 -202 126 -42 0 -79 -7 -106 -19z m223 -27 c32 -24 73 -80 73 -100 0 -11 -37 -14 -190 -14 -126 0 -190 4 -190 10 0 19 27 64 52 87 37 35 68 43 150 40 59 -2 83 -7 105 -23z m-342 -16 c-8 -13 -20 -40 -26 -60 l-10 -38 -59 0 c-53 0 -60 2 -60 19 0 24 46 80 74 91 12 5 38 9 59 9 38 1 38 1 22 -21z m572 -22 c18 -19 33 -45 33 -56 0 -18 -7 -20 -60 -20 l-59 0 -10 38 c-6 20 -18 48 -27 61 l-17 24 53 -5 c46 -5 59 -11 87 -42z m43 -206 l0 -110 -390 0 -390 0 0 110 0 110 390 0 390 0 0 -110z"/> <path d="M1318 444 c-5 -4 -8 -20 -8 -36 0 -24 4 -28 28 -28 24 1 25 2 10 13 -9 7 -18 23 -20 36 -1 13 -6 19 -10 15z"/> <path d="M1370 415 c0 -31 3 -35 26 -35 14 0 23 4 19 10 -4 6 -11 8 -16 5 -5 -4 -9 -2 -9 4 0 5 8 12 18 14 15 4 14 5 -2 6 -20 1 -20 1 0 16 18 14 18 14 -8 15 -25 0 -28 -3 -28 -35z"/> <path d="M1441 418 c-12 -33 -6 -52 9 -28 7 11 11 11 24 1 19 -16 21 -4 6 33 -13 35 -26 33 -39 -6z"/> <path d="M1510 415 c0 -32 3 -36 23 -33 17 2 22 10 22 33 0 23 -5 31 -22 33 -20 3 -23 -1 -23 -33z m38 -3 c2 -7 -3 -12 -12 -12 -9 0 -16 7 -16 16 0 17 22 14 28 -4z"/> <path d="M1580 415 c0 -28 4 -35 20 -35 25 0 27 20 3 21 -15 0 -15 2 2 8 20 8 20 8 0 13 -16 5 -17 6 -2 7 24 1 22 21 -3 21 -16 0 -20 -7 -20 -35z"/> <path d="M1640 413 c0 -30 3 -35 11 -23 8 11 12 12 16 3 9 -25 21 -13 20 20 -2 25 -7 33 -24 35 -20 3 -23 -1 -23 -35z m27 10 c-4 -3 -10 -3 -14 0 -3 4 0 7 7 7 7 0 10 -3 7 -7z"/> </g>
    </SvgIcon>
  );
}

export function StairStepperIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="11.000000pt"
      height="13.000000pt"
      viewBox="0 0 300.000000 300.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <metadata>Stair stepper Icon</metadata>
      <g
        transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
        fill="#333333"
        stroke="none"
      >
        <path d="M1363 5537 c-93 -27 -248 -188 -279 -289 -155 -523 539 -842 825 -379 222 358 -130 788 -546 668z" />
        <path d="M1085 4492 c-486 -233 -616 -351 -813 -736 -151 -298 -161 -363 -65 -454 145 -135 264 -66 427 250 110 213 228 372 256 345 5 -5 -17 -135 -50 -288 -99 -461 -59 -616 185 -718 42 -18 70 -42 65 -56 -4 -14 -45 -196 -90 -405 -45 -209 -108 -500 -141 -647 -32 -146 -59 -279 -59 -295 0 -23 46 -28 236 -28 l237 0 138 642 c164 756 129 678 289 654 160 -24 135 12 210 -301 l63 -265 244 -6 c133 -3 243 0 243 6 0 61 -191 777 -220 825 -62 103 -172 161 -371 197 -227 42 -215 18 -156 298 62 289 49 273 142 177 109 -111 180 -139 484 -184 307 -46 373 -34 430 74 95 184 -6 282 -340 330 -285 42 -249 22 -407 233 -266 355 -297 376 -606 391 -213 11 -232 9 -331 -39z" />
        <path d="M4851 4029 c-25 -26 -31 -85 -31 -322 0 -403 50 -367 -508 -367 -571 0 -520 35 -529 -368 -3 -170 -15 -313 -27 -327 -16 -19 -132 -25 -464 -25 -576 0 -532 30 -532 -361 0 -410 44 -379 -539 -379 -550 0 -501 36 -501 -367 0 -385 47 -353 -517 -353 -327 0 -462 -7 -479 -24 -46 -46 -32 -650 15 -675 71 -38 5002 -28 5057 10 l44 31 0 1755 c0 1338 -6 1761 -24 1779 -40 40 -924 33 -965 -7z" />
      </g>
    </svg>
  );
}
